var $a0b4f895e1596b3b$exports = {};
!function(r) {
    "use strict";
    function n(r, n, t) {
        return t.a = r, t.f = n, t;
    }
    function F2(r) {
        return n(2, r, function(n) {
            return function(t) {
                return r(n, t);
            };
        });
    }
    function F3(r) {
        return n(3, r, function(n) {
            return function(t) {
                return function(e) {
                    return r(n, t, e);
                };
            };
        });
    }
    function F4(r) {
        return n(4, r, function(n) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return r(n, t, e, u);
                    };
                };
            };
        });
    }
    function F5(r) {
        return n(5, r, function(n) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return r(n, t, e, u, a);
                        };
                    };
                };
            };
        });
    }
    function F6(r) {
        return n(6, r, function(n) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return r(n, t, e, u, a, i);
                            };
                        };
                    };
                };
            };
        });
    }
    function F7(r) {
        return n(7, r, function(n) {
            return function(t) {
                return function(e) {
                    return function(u) {
                        return function(a) {
                            return function(i) {
                                return function(o) {
                                    return r(n, t, e, u, a, i, o);
                                };
                            };
                        };
                    };
                };
            };
        });
    }
    function A2(r, n, t) {
        return 2 === r.a ? r.f(n, t) : r(n)(t);
    }
    function A3(r, n, t, e) {
        return 3 === r.a ? r.f(n, t, e) : r(n)(t)(e);
    }
    function A4(r, n, t, e, u) {
        return 4 === r.a ? r.f(n, t, e, u) : r(n)(t)(e)(u);
    }
    function A5(r, n, t, e, u, a) {
        return 5 === r.a ? r.f(n, t, e, u, a) : r(n)(t)(e)(u)(a);
    }
    function A6(r, n, t, e, u, a, i) {
        return 6 === r.a ? r.f(n, t, e, u, a, i) : r(n)(t)(e)(u)(a)(i);
    }
    function A7(r, n, t, e, u, a, i, o) {
        return 7 === r.a ? r.f(n, t, e, u, a, i, o) : r(n)(t)(e)(u)(a)(i)(o);
    }
    var t = F3(function(r, n, t) {
        for(var e = Array(r), u = 0; r > u; u++)e[u] = t(n + u);
        return e;
    }), e = F2(function(r, n) {
        for(var t = Array(r), e = 0; r > e && n.b; e++)t[e] = n.a, n = n.b;
        return t.length = e, p(t, n);
    }), u = F2(function(r, n) {
        return n[r];
    }), a = F3(function(r, n, t) {
        for(var e = t.length, u = Array(e), a = 0; e > a; a++)u[a] = t[a];
        return u[r] = n, u;
    }), i = F2(function(r, n) {
        for(var t = n.length, e = Array(t + 1), u = 0; t > u; u++)e[u] = n[u];
        return e[t] = r, e;
    }), o = F3(function(r, n, t) {
        for(var e = t.length, u = 0; e > u; u++)n = A2(r, t[u], n);
        return n;
    }), f = F3(function(r, n, t) {
        for(var e = t.length - 1; e >= 0; e--)n = A2(r, t[e], n);
        return n;
    }), c = F3(function(r, n, t) {
        return t.slice(r, n);
    }), s = F3(function(r, n, t) {
        var e = n.length, u = r - e;
        u > t.length && (u = t.length);
        for(var a = Array(e + u), i = 0; e > i; i++)a[i] = n[i];
        for(i = 0; u > i; i++)a[i + e] = t[i];
        return a;
    });
    function l(r) {
        throw Error("https://github.com/elm/core/blob/1.0.0/hints/" + r + ".md");
    }
    function b(r, n) {
        for(var t, e = [], u = v(r, n, 0, e); u && (t = e.pop()); u = v(t.a, t.b, 0, e));
        return u;
    }
    function v(r, n, t, e) {
        if (r === n) return !0;
        if ("object" != typeof r || null === r || null === n) return "function" == typeof r && l(5), !1;
        if (t > 100) return e.push(p(r, n)), !0;
        for(var u in 0 > r.$ && (r = Fn(r), n = Fn(n)), r)if (!v(r[u], n[u], t + 1, e)) return !1;
        return !0;
    }
    function d(r, n, t) {
        if ("object" != typeof r) return r === n ? 0 : n > r ? -1 : 1;
        if (void 0 === r.$) return (t = d(r.a, n.a)) || (t = d(r.b, n.b)) ? t : d(r.c, n.c);
        for(; r.b && n.b && !(t = d(r.a, n.a)); r = r.b, n = n.b);
        return t || (r.b ? 1 : n.b ? -1 : 0);
    }
    var h = F2(function(r, n) {
        var t = d(r, n);
        return 0 > t ? Nn : t ? Hn : _n;
    }), g = 0;
    function p(r, n) {
        return {
            a: r,
            b: n
        };
    }
    function $(r, n, t) {
        return {
            a: r,
            b: n,
            c: t
        };
    }
    function m(r, n) {
        var t = {};
        for(var e in r)t[e] = r[e];
        for(var e in n)t[e] = n[e];
        return t;
    }
    function w(r, n) {
        if ("string" == typeof r) return r + n;
        if (!r.b) return n;
        var t = x(r.a, n);
        r = r.b;
        for(var e = t; r.b; r = r.b)e = e.b = x(r.a, n);
        return t;
    }
    var y = {
        $: 0
    };
    function x(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }
    var k = F2(x);
    function S(r) {
        for(var n = y, t = r.length; t--;)n = x(r[t], n);
        return n;
    }
    function I(r) {
        for(var n = []; r.b; r = r.b)n.push(r.a);
        return n;
    }
    var R = F3(function(r, n, t) {
        for(var e = []; n.b && t.b; n = n.b, t = t.b)e.push(A2(r, n.a, t.a));
        return S(e);
    }), J = F2(function(r, n) {
        return S(I(n).sort(function(n, t) {
            return d(r(n), r(t));
        }));
    }), E = Math.ceil, A = Math.floor, j = Math.round, C = Math.log, q = F2(function(r, n) {
        return r + n;
    }), T = F3(function(r, n, t) {
        for(var e = t.length; e--;){
            var u = t[e], a = t.charCodeAt(e);
            56320 > a || a > 57343 || (u = t[--e] + u), n = A2(r, u, n);
        }
        return n;
    }), L = F2(function(r, n) {
        return n.split(r);
    }), F = F2(function(r, n) {
        return n.join(r);
    }), _ = F3(function(r, n, t) {
        return t.slice(r, n);
    }), H = F2(function(r, n) {
        return n.indexOf(r) > -1;
    }), N = F2(function(r, n) {
        return 0 === n.indexOf(r);
    }), O = F2(function(r, n) {
        return n.length >= r.length && n.lastIndexOf(r) === n.length - r.length;
    }), B = F2(function(r, n) {
        var t = r.length;
        if (1 > t) return y;
        for(var e = 0, u = []; (e = n.indexOf(r, e)) > -1;)u.push(e), e += t;
        return S(u);
    });
    function G(r) {
        return r + "";
    }
    function z(r) {
        return {
            $: 2,
            b: r
        };
    }
    var D = z(function(r) {
        return "number" != typeof r ? tr("an INT", r) : r > -2147483647 && 2147483647 > r && (0 | r) === r ? Dn(r) : !isFinite(r) || r % 1 ? tr("an INT", r) : Dn(r);
    }), W = z(function(r) {
        return "boolean" == typeof r ? Dn(r) : tr("a BOOL", r);
    }), U = (z(function(r) {
        return "number" == typeof r ? Dn(r) : tr("a FLOAT", r);
    }), z(function(r) {
        return Dn(r);
    }), z(function(r) {
        return "string" == typeof r ? Dn(r) : r instanceof String ? Dn(r + "") : tr("a STRING", r);
    })), V = F2(function(r, n) {
        return {
            $: 6,
            d: r,
            b: n
        };
    });
    function P(r, n) {
        return {
            $: 9,
            f: r,
            g: n
        };
    }
    var M = F2(function(r, n) {
        return {
            $: 10,
            b: n,
            h: r
        };
    }), K = F2(function(r, n) {
        return P(r, [
            n
        ]);
    }), Y = F3(function(r, n, t) {
        return P(r, [
            n,
            t
        ]);
    }), X = F2(function(r, n) {
        return Z(r, n);
    });
    function Z(r, n) {
        switch(r.$){
            case 2:
                return r.b(n);
            case 5:
                return null === n ? Dn(r.c) : tr("null", n);
            case 3:
                return rr(n) ? Q(r.b, n, S) : tr("a LIST", n);
            case 4:
                return rr(n) ? Q(r.b, n, nr) : tr("an ARRAY", n);
            case 6:
                var t = r.d;
                if ("object" != typeof n || null === n || !(t in n)) return tr("an OBJECT with a field named `" + t + "`", n);
                var e = Z(r.b, n[t]);
                return kt(e) ? e : On(A2(Gn, t, e.a));
            case 7:
                var u = r.e;
                return rr(n) ? n.length > u ? (e = Z(r.b, n[u]), kt(e) ? e : On(A2(zn, u, e.a))) : tr("a LONGER array. Need index " + u + " but only see " + n.length + " entries", n) : tr("an ARRAY", n);
            case 8:
                if ("object" != typeof n || null === n || rr(n)) return tr("an OBJECT", n);
                var a = y;
                for(var i in n)if (n.hasOwnProperty(i)) {
                    if (e = Z(r.b, n[i]), !kt(e)) return On(A2(Gn, i, e.a));
                    a = x(p(i, e.a), a);
                }
                return Dn(tt(a));
            case 9:
                for(var o = r.f, f = r.g, c = 0; f.length > c; c++){
                    if (e = Z(f[c], n), !kt(e)) return e;
                    o = o(e.a);
                }
                return Dn(o);
            case 10:
                return e = Z(r.b, n), kt(e) ? Z(r.h(e.a), n) : e;
            case 11:
                for(var s = y, l = r.g; l.b; l = l.b){
                    if (e = Z(l.a, n), kt(e)) return e;
                    s = x(e.a, s);
                }
                return On(Wn(tt(s)));
            case 1:
                return On(A2(Bn, r.a, n));
            case 0:
                return Dn(r.a);
        }
    }
    function Q(r, n, t) {
        for(var e = n.length, u = Array(e), a = 0; e > a; a++){
            var i = Z(r, n[a]);
            if (!kt(i)) return On(A2(zn, a, i.a));
            u[a] = i.a;
        }
        return Dn(t(u));
    }
    function rr(r) {
        return Array.isArray(r) || "undefined" != typeof FileList && r instanceof FileList;
    }
    function nr(r) {
        return A2(xt, r.length, function(n) {
            return r[n];
        });
    }
    function tr(r, n) {
        return On(A2(Bn, "Expecting " + r, n));
    }
    function er(r, n) {
        if (r === n) return !0;
        if (r.$ !== n.$) return !1;
        switch(r.$){
            case 0:
            case 1:
                return r.a === n.a;
            case 2:
                return r.b === n.b;
            case 5:
                return r.c === n.c;
            case 3:
            case 4:
            case 8:
                return er(r.b, n.b);
            case 6:
                return r.d === n.d && er(r.b, n.b);
            case 7:
                return r.e === n.e && er(r.b, n.b);
            case 9:
                return r.f === n.f && ur(r.g, n.g);
            case 10:
                return r.h === n.h && er(r.b, n.b);
            case 11:
                return ur(r.g, n.g);
        }
    }
    function ur(r, n) {
        var t = r.length;
        if (t !== n.length) return !1;
        for(var e = 0; t > e; e++)if (!er(r[e], n[e])) return !1;
        return !0;
    }
    function ar(r) {
        return r;
    }
    var ir = F3(function(r, n, t) {
        return t[r] = n, t;
    });
    function or(r) {
        return F2(function(n, t) {
            return t.push(r(n)), t;
        });
    }
    function fr(r) {
        return {
            $: 0,
            a: r
        };
    }
    function cr(r) {
        return {
            $: 2,
            b: r,
            c: null
        };
    }
    var sr = F2(function(r, n) {
        return {
            $: 3,
            b: r,
            d: n
        };
    }), lr = F2(function(r, n) {
        return {
            $: 4,
            b: r,
            d: n
        };
    }), br = 0;
    function vr(r) {
        var n = {
            $: 0,
            e: br++,
            f: r,
            g: null,
            h: []
        };
        return mr(n), n;
    }
    function dr(r) {
        return cr(function(n) {
            n(fr(vr(r)));
        });
    }
    function hr(r, n) {
        r.h.push(n), mr(r);
    }
    var gr = F2(function(r, n) {
        return cr(function(t) {
            hr(r, n), t(fr(g));
        });
    }), pr = !1, $r = [];
    function mr(r) {
        if ($r.push(r), !pr) {
            for(pr = !0; r = $r.shift();)wr(r);
            pr = !1;
        }
    }
    function wr(r) {
        for(; r.f;){
            var n = r.f.$;
            if (0 === n || 1 === n) {
                for(; r.g && r.g.$ !== n;)r.g = r.g.i;
                if (!r.g) return;
                r.f = r.g.b(r.f.a), r.g = r.g.i;
            } else {
                if (2 === n) return void (r.f.c = r.f.b(function(n) {
                    r.f = n, mr(r);
                }));
                if (5 === n) {
                    if (0 === r.h.length) return;
                    r.f = r.f.b(r.h.shift());
                } else r.g = {
                    $: 3 === n ? 0 : 1,
                    b: r.f.b,
                    i: r.g
                }, r.f = r.f.d;
            }
        }
    }
    var yr = {};
    function xr(r, n, t, e, u) {
        return {
            b: r,
            c: n,
            d: t,
            e: e,
            f: u
        };
    }
    function kr(r, n) {
        var t = {
            g: n,
            h: void 0
        }, e = r.c, u = r.d, a = r.e, i = r.f;
        function o(r) {
            return A2(sr, o, {
                $: 5,
                b: function(n) {
                    var o = n.a;
                    return 0 === n.$ ? A3(u, t, o, r) : a && i ? A4(e, t, o.i, o.j, r) : A3(e, t, a ? o.i : o.j, r);
                }
            });
        }
        return t.h = vr(A2(sr, o, r.b));
    }
    var Sr = F2(function(r, n) {
        return cr(function(t) {
            r.g(n), t(fr(g));
        });
    }), Ir = F2(function(r, n) {
        return A2(gr, r.h, {
            $: 0,
            a: n
        });
    });
    function Rr(r) {
        return function(n) {
            return {
                $: 1,
                k: r,
                l: n
            };
        };
    }
    var Jr = F2(function(r, n) {
        return {
            $: 3,
            n: r,
            o: n
        };
    }), Er = [], Ar = !1;
    function jr(r, n, t) {
        if (Er.push({
            p: r,
            q: n,
            r: t
        }), !Ar) {
            Ar = !0;
            for(var e; e = Er.shift();)Cr(e.p, e.q, e.r);
            Ar = !1;
        }
    }
    function Cr(r, n, t) {
        var e = {};
        for(var u in qr(!0, n, e, null), qr(!1, t, e, null), r)hr(r[u], {
            $: "fx",
            a: e[u] || {
                i: y,
                j: y
            }
        });
    }
    function qr(r, n, t, e) {
        switch(n.$){
            case 1:
                var u = n.k, a = function(r, n, t, e) {
                    function u(r) {
                        for(var n = t; n; n = n.t)r = n.s(r);
                        return r;
                    }
                    return A2(r ? yr[n].e : yr[n].f, u, e);
                }(r, u, e, n.l);
                return void (t[u] = function(r, n, t) {
                    return t = t || {
                        i: y,
                        j: y
                    }, r ? t.i = x(n, t.i) : t.j = x(n, t.j), t;
                }(r, a, t[u]));
            case 2:
                for(var i = n.m; i.b; i = i.b)qr(r, i.a, t, e);
                return;
            case 3:
                return void qr(r, n.o, t, {
                    s: n.n,
                    t: e
                });
        }
    }
    function Tr(r, n) {
        return function(r) {
            yr[r] && l(3);
        }(r), yr[r] = {
            e: Fr,
            u: n,
            a: _r
        }, Rr(r);
    }
    var Lr, Fr = F2(function(r, n) {
        return n;
    });
    function _r(r) {
        var n = [], t = yr[r].u, e = cr(function(r) {
            var n = setTimeout(function() {
                r(fr(g));
            }, 0);
            return function() {
                clearTimeout(n);
            };
        });
        return yr[r].b = e, yr[r].c = F3(function(r, u) {
            for(; u.b; u = u.b)for(var a = n, i = t(u.a), o = 0; a.length > o; o++)a[o](i);
            return e;
        }), {
            subscribe: function(r) {
                n.push(r);
            },
            unsubscribe: function(r) {
                var t = (n = n.slice()).indexOf(r);
                0 > t || n.splice(t, 1);
            }
        };
    }
    var Hr = "undefined" != typeof document ? document : {};
    function Nr(r, n) {
        r.appendChild(n);
    }
    function Or(r) {
        return {
            $: 0,
            a: r
        };
    }
    var Br = F2(function(r, n) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 1,
                c: n,
                d: Kr(t),
                e: u,
                f: r,
                b: a
            };
        });
    }), Gr = Br(void 0);
    F2(function(r, n) {
        return F2(function(t, e) {
            for(var u = [], a = 0; e.b; e = e.b){
                var i = e.a;
                a += i.b.b || 0, u.push(i);
            }
            return a += u.length, {
                $: 2,
                c: n,
                d: Kr(t),
                e: u,
                f: r,
                b: a
            };
        });
    })(void 0);
    var zr, Dr = F2(function(r, n) {
        return {
            $: 4,
            j: r,
            k: n,
            b: 1 + (n.b || 0)
        };
    }), Wr = F2(function(r, n) {
        return {
            $: "a0",
            n: r,
            o: n
        };
    }), Ur = F2(function(r, n) {
        return {
            $: "a1",
            n: r,
            o: n
        };
    }), Vr = F2(function(r, n) {
        return {
            $: "a2",
            n: r,
            o: n
        };
    }), Pr = F2(function(r, n) {
        return {
            $: "a3",
            n: r,
            o: n
        };
    }), Mr = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
    function Kr(r) {
        for(var n = {}; r.b; r = r.b){
            var t = r.a, e = t.$, u = t.n, a = t.o;
            if ("a2" !== e) {
                var i = n[e] || (n[e] = {});
                "a3" === e && "class" === u ? Yr(i, u, a) : i[u] = a;
            } else "className" === u ? Yr(n, u, a) : n[u] = a;
        }
        return n;
    }
    function Yr(r, n, t) {
        var e = r[n];
        r[n] = e ? e + " " + t : t;
    }
    function Xr(r, n) {
        var t = r.$;
        if (5 === t) return Xr(r.k || (r.k = r.m()), n);
        if (0 === t) return Hr.createTextNode(r.a);
        if (4 === t) {
            for(var e = r.k, u = r.j; 4 === e.$;)"object" != typeof u ? u = [
                u,
                e.j
            ] : u.push(e.j), e = e.k;
            var a = {
                j: u,
                p: n
            };
            return (i = Xr(e, a)).elm_event_node_ref = a, i;
        }
        if (3 === t) return Zr(i = r.h(r.g), n, r.d), i;
        var i = r.f ? Hr.createElementNS(r.f, r.c) : Hr.createElement(r.c);
        Lr && "a" == r.c && i.addEventListener("click", Lr(i)), Zr(i, n, r.d);
        for(var o = r.e, f = 0; o.length > f; f++)Nr(i, Xr(1 === t ? o[f] : o[f].b, n));
        return i;
    }
    function Zr(r, n, t) {
        for(var e in t){
            var u = t[e];
            "a1" === e ? Qr(r, u) : "a0" === e ? tn(r, n, u) : "a3" === e ? rn(r, u) : "a4" === e ? nn(r, u) : ("value" !== e && "checked" !== e || r[e] !== u) && (r[e] = u);
        }
    }
    function Qr(r, n) {
        var t = r.style;
        for(var e in n)t[e] = n[e];
    }
    function rn(r, n) {
        for(var t in n){
            var e = n[t];
            void 0 !== e ? r.setAttribute(t, e) : r.removeAttribute(t);
        }
    }
    function nn(r, n) {
        for(var t in n){
            var e = n[t], u = e.f, a = e.o;
            void 0 !== a ? r.setAttributeNS(u, t, a) : r.removeAttributeNS(u, t);
        }
    }
    function tn(r, n, t) {
        var e = r.elmFs || (r.elmFs = {});
        for(var u in t){
            var a = t[u], i = e[u];
            if (a) {
                if (i) {
                    if (i.q.$ === a.$) {
                        i.q = a;
                        continue;
                    }
                    r.removeEventListener(u, i);
                }
                i = en(n, a), r.addEventListener(u, i, zr && {
                    passive: 2 > Et(a)
                }), e[u] = i;
            } else r.removeEventListener(u, i), e[u] = void 0;
        }
    }
    try {
        window.addEventListener("t", null, Object.defineProperty({}, "passive", {
            get: function() {
                zr = !0;
            }
        }));
    } catch (r) {}
    function en(r, n) {
        function t(n) {
            var e = t.q, u = Z(e.a, n);
            if (kt(u)) {
                for(var a, i = Et(e), o = u.a, f = i ? 3 > i ? o.a : o.z : o, c = 1 == i ? o.b : 3 == i && o.au, s = (c && n.stopPropagation(), (2 == i ? o.b : 3 == i && o.ao) && n.preventDefault(), r); a = s.j;){
                    if ("function" == typeof a) f = a(f);
                    else for(var l = a.length; l--;)f = a[l](f);
                    s = s.p;
                }
                s(f, c);
            }
        }
        return t.q = n, t;
    }
    function un(r, n) {
        return r.$ == n.$ && er(r.a, n.a);
    }
    function an(r, n, t, e) {
        var u = {
            $: n,
            r: t,
            s: e,
            t: void 0,
            u: void 0
        };
        return r.push(u), u;
    }
    function on(r, n, t, e) {
        if (r !== n) {
            var u = r.$, a = n.$;
            if (u !== a) {
                if (1 !== u || 2 !== a) return void an(t, 0, e, n);
                n = function(r) {
                    for(var n = r.e, t = n.length, e = Array(t), u = 0; t > u; u++)e[u] = n[u].b;
                    return {
                        $: 1,
                        c: r.c,
                        d: r.d,
                        e: e,
                        f: r.f,
                        b: r.b
                    };
                }(n), a = 1;
            }
            switch(a){
                case 5:
                    for(var i = r.l, o = n.l, f = i.length, c = f === o.length; c && f--;)c = i[f] === o[f];
                    if (c) return void (n.k = r.k);
                    n.k = n.m();
                    var s = [];
                    return on(r.k, n.k, s, 0), void (s.length > 0 && an(t, 1, e, s));
                case 4:
                    for(var l = r.j, b = n.j, v = !1, d = r.k; 4 === d.$;)v = !0, "object" != typeof l ? l = [
                        l,
                        d.j
                    ] : l.push(d.j), d = d.k;
                    for(var h = n.k; 4 === h.$;)v = !0, "object" != typeof b ? b = [
                        b,
                        h.j
                    ] : b.push(h.j), h = h.k;
                    return v && l.length !== b.length ? void an(t, 0, e, n) : ((v ? function(r, n) {
                        for(var t = 0; r.length > t; t++)if (r[t] !== n[t]) return !1;
                        return !0;
                    }(l, b) : l === b) || an(t, 2, e, b), void on(d, h, t, e + 1));
                case 0:
                    return void (r.a !== n.a && an(t, 3, e, n.a));
                case 1:
                    return void fn(r, n, t, e, sn);
                case 2:
                    return void fn(r, n, t, e, ln);
                case 3:
                    if (r.h !== n.h) return void an(t, 0, e, n);
                    var g = cn(r.d, n.d);
                    g && an(t, 4, e, g);
                    var p = n.i(r.g, n.g);
                    return void (p && an(t, 5, e, p));
            }
        }
    }
    function fn(r, n, t, e, u) {
        if (r.c === n.c && r.f === n.f) {
            var a = cn(r.d, n.d);
            a && an(t, 4, e, a), u(r, n, t, e);
        } else an(t, 0, e, n);
    }
    function cn(r, n, t) {
        var e;
        for(var u in r)if ("a1" !== u && "a0" !== u && "a3" !== u && "a4" !== u) {
            if (u in n) {
                var a = r[u], i = n[u];
                a === i && "value" !== u && "checked" !== u || "a0" === t && un(a, i) || ((e = e || {})[u] = i);
            } else (e = e || {})[u] = t ? "a1" === t ? "" : "a0" === t || "a3" === t ? void 0 : {
                f: r[u].f,
                o: void 0
            } : "string" == typeof r[u] ? "" : null;
        } else {
            var o = cn(r[u], n[u] || {}, u);
            o && ((e = e || {})[u] = o);
        }
        for(var f in n)f in r || ((e = e || {})[f] = n[f]);
        return e;
    }
    function sn(r, n, t, e) {
        var u = r.e, a = n.e, i = u.length, o = a.length;
        i > o ? an(t, 6, e, {
            v: o,
            i: i - o
        }) : o > i && an(t, 7, e, {
            v: i,
            e: a
        });
        for(var f = o > i ? i : o, c = 0; f > c; c++){
            var s = u[c];
            on(s, a[c], t, ++e), e += s.b || 0;
        }
    }
    function ln(r, n, t, e) {
        for(var u = [], a = {}, i = [], o = r.e, f = n.e, c = o.length, s = f.length, l = 0, b = 0, v = e; c > l && s > b;){
            var d = (R = o[l]).a, h = (J = f[b]).a, g = R.b, p = J.b, $ = void 0, m = void 0;
            if (d !== h) {
                var w = o[l + 1], y = f[b + 1];
                if (w) {
                    var x = w.a, k = w.b;
                    m = h === x;
                }
                if (y) {
                    var S = y.a, I = y.b;
                    $ = d === S;
                }
                if ($ && m) on(g, I, u, ++v), vn(a, u, d, p, b, i), v += g.b || 0, dn(a, u, d, k, ++v), v += k.b || 0, l += 2, b += 2;
                else if ($) v++, vn(a, u, h, p, b, i), on(g, I, u, v), v += g.b || 0, l += 1, b += 2;
                else if (m) dn(a, u, d, g, ++v), v += g.b || 0, on(k, p, u, ++v), v += k.b || 0, l += 2, b += 1;
                else {
                    if (!w || x !== S) break;
                    dn(a, u, d, g, ++v), vn(a, u, h, p, b, i), v += g.b || 0, on(k, I, u, ++v), v += k.b || 0, l += 2, b += 2;
                }
            } else on(g, p, u, ++v), v += g.b || 0, l++, b++;
        }
        for(; c > l;){
            var R;
            v++, dn(a, u, (R = o[l]).a, g = R.b, v), v += g.b || 0, l++;
        }
        for(; s > b;){
            var J, E = E || [];
            vn(a, u, (J = f[b]).a, J.b, void 0, E), b++;
        }
        (u.length > 0 || i.length > 0 || E) && an(t, 8, e, {
            w: u,
            x: i,
            y: E
        });
    }
    var bn = "_elmW6BL";
    function vn(r, n, t, e, u, a) {
        var i = r[t];
        if (!i) return a.push({
            r: u,
            A: i = {
                c: 0,
                z: e,
                r: u,
                s: void 0
            }
        }), void (r[t] = i);
        if (1 === i.c) {
            a.push({
                r: u,
                A: i
            }), i.c = 2;
            var o = [];
            return on(i.z, e, o, i.r), i.r = u, void (i.s.s = {
                w: o,
                A: i
            });
        }
        vn(r, n, t + bn, e, u, a);
    }
    function dn(r, n, t, e, u) {
        var a = r[t];
        if (a) {
            if (0 === a.c) {
                a.c = 2;
                var i = [];
                return on(e, a.z, i, u), void an(n, 9, u, {
                    w: i,
                    A: a
                });
            }
            dn(r, n, t + bn, e, u);
        } else {
            var o = an(n, 9, u, void 0);
            r[t] = {
                c: 1,
                z: e,
                r: u,
                s: o
            };
        }
    }
    function hn(r, n, t, e) {
        gn(r, n, t, 0, 0, n.b, e);
    }
    function gn(r, n, t, e, u, a, i) {
        for(var o = t[e], f = o.r; f === u;){
            var c = o.$;
            if (1 === c) hn(r, n.k, o.s, i);
            else if (8 === c) o.t = r, o.u = i, (s = o.s.w).length > 0 && gn(r, n, s, 0, u, a, i);
            else if (9 === c) {
                o.t = r, o.u = i;
                var s, l = o.s;
                l && (l.A.s = r, (s = l.w).length > 0 && gn(r, n, s, 0, u, a, i));
            } else o.t = r, o.u = i;
            if (!(o = t[++e]) || (f = o.r) > a) return e;
        }
        var b = n.$;
        if (4 === b) {
            for(var v = n.k; 4 === v.$;)v = v.k;
            return gn(r, v, t, e, u + 1, a, r.elm_event_node_ref);
        }
        for(var d = n.e, h = r.childNodes, g = 0; d.length > g; g++){
            u++;
            var p = 1 === b ? d[g] : d[g].b, $ = u + (p.b || 0);
            if (!(u > f || f > $ || (o = t[e = gn(h[g], p, t, e, u, $, i)]) && (f = o.r) <= a)) return e;
            u = $;
        }
        return e;
    }
    function pn(r, n) {
        for(var t = 0; n.length > t; t++){
            var e = n[t], u = e.t, a = $n(u, e);
            u === r && (r = a);
        }
        return r;
    }
    function $n(r, n) {
        switch(n.$){
            case 0:
                return function(r, n, t) {
                    var e = r.parentNode, u = Xr(n, t);
                    return u.elm_event_node_ref || (u.elm_event_node_ref = r.elm_event_node_ref), e && u !== r && e.replaceChild(u, r), u;
                }(r, n.s, n.u);
            case 4:
                return Zr(r, n.u, n.s), r;
            case 3:
                return r.replaceData(0, r.length, n.s), r;
            case 1:
                return pn(r, n.s);
            case 2:
                return r.elm_event_node_ref ? r.elm_event_node_ref.j = n.s : r.elm_event_node_ref = {
                    j: n.s,
                    p: n.u
                }, r;
            case 6:
                for(var t = n.s, e = 0; t.i > e; e++)r.removeChild(r.childNodes[t.v]);
                return r;
            case 7:
                for(var u = (t = n.s).e, a = r.childNodes[e = t.v]; u.length > e; e++)r.insertBefore(Xr(u[e], n.u), a);
                return r;
            case 9:
                if (!(t = n.s)) return r.parentNode.removeChild(r), r;
                var i = t.A;
                return void 0 !== i.r && r.parentNode.removeChild(r), i.s = pn(r, t.w), r;
            case 8:
                return function(r, n) {
                    var t = n.s, e = function(r, n) {
                        if (r) {
                            for(var t = Hr.createDocumentFragment(), e = 0; r.length > e; e++){
                                var u = r[e].A;
                                Nr(t, 2 === u.c ? u.s : Xr(u.z, n.u));
                            }
                            return t;
                        }
                    }(t.y, n);
                    r = pn(r, t.w);
                    for(var u = t.x, a = 0; u.length > a; a++){
                        var i = u[a], o = i.A, f = 2 === o.c ? o.s : Xr(o.z, n.u);
                        r.insertBefore(f, r.childNodes[i.r]);
                    }
                    return e && Nr(r, e), r;
                }(r, n);
            case 5:
                return n.s(r);
            default:
                l(10);
        }
    }
    function mn(r) {
        if (3 === r.nodeType) return Or(r.textContent);
        if (1 !== r.nodeType) return Or("");
        for(var n = y, t = r.attributes, e = t.length; e--;){
            var u = t[e];
            n = x(A2(Pr, u.name, u.value), n);
        }
        var a = r.tagName.toLowerCase(), i = y, o = r.childNodes;
        for(e = o.length; e--;)i = x(mn(o[e]), i);
        return A3(Gr, a, n, i);
    }
    var wn = F4(function(r, n, t, e) {
        return function(r, n, t, e, u, a) {
            var i = A2(X, r, n ? n.flags : void 0);
            kt(i) || l(2);
            var o = {}, f = t(i.a), c = f.a, s = a(v, c), b = function(r, n) {
                var t;
                for(var e in yr){
                    var u = yr[e];
                    u.a && ((t = t || {})[e] = u.a(e, n)), r[e] = kr(u, n);
                }
                return t;
            }(o, v);
            function v(r, n) {
                var t = A2(e, r, c);
                s(c = t.a, n), jr(o, t.b, u(c));
            }
            return jr(o, f.b, u(c)), b ? {
                ports: b
            } : {};
        }(n, e, r.bb, r.bq, r.bo, function(n, t) {
            var e = r.ar && r.ar(n), u = r.bs, a = Hr.title, i = Hr.body, o = mn(i);
            return function(r, n) {
                n(r);
                var t = 0;
                function e() {
                    t = 1 === t ? 0 : (yn(e), n(r), 1);
                }
                return function(u, a) {
                    r = u, a ? (n(r), 2 === t && (t = 1)) : (0 === t && yn(e), t = 2);
                };
            }(t, function(r) {
                Lr = e;
                var t = u(r), f = Gr("body")(y)(t.a2), c = function(r, n) {
                    var t = [];
                    return on(r, n, t, 0), t;
                }(o, f);
                i = function(r, n, t, e) {
                    return 0 === t.length ? r : (hn(r, n, t, e), pn(r, t));
                }(i, o, c, n), o = f, Lr = 0, a !== t.bp && (Hr.title = a = t.bp);
            });
        });
    }), yn = ("undefined" != typeof cancelAnimationFrame && cancelAnimationFrame, "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : function(r) {
        return setTimeout(r, 1e3 / 60);
    });
    function xn() {
        return Wt(Hr.location.href).a || l(1);
    }
    var kn = F2(function(r, n) {
        return A2(ue, Ut, cr(function() {
            history.pushState({}, "", n), r();
        }));
    }), Sn = {
        addEventListener: function() {},
        removeEventListener: function() {}
    }, In = "undefined" != typeof document ? document : Sn, Rn = "undefined" != typeof window ? window : Sn, Jn = F3(function(r, n, t) {
        return dr(cr(function() {
            function e(r) {
                vr(t(r));
            }
            return r.addEventListener(n, e, zr && {
                passive: !0
            }), function() {
                r.removeEventListener(n, e);
            };
        }));
    }), En = F2(function(r, n) {
        var t = Z(r, n);
        return kt(t) ? Un(t.a) : Vn;
    });
    var An = F3(function(r, n, t) {
        return function(r, n) {
            return cr(function(t) {
                yn(function() {
                    var e = document.getElementById(r);
                    t(e ? fr(n(e)) : {
                        $: 1,
                        a: jt(r)
                    });
                });
            });
        }(r, function(r) {
            return r.scrollLeft = n, r.scrollTop = t, g;
        });
    }), jn = k, Cn = f, qn = F3(function(r, n, t) {
        var e = t.c, u = t.d, a = F2(function(n, t) {
            return A3(Cn, n.$ ? r : a, t, n.a);
        });
        return A3(Cn, a, A3(Cn, r, n, u), e);
    }), Tn = function(r) {
        return A3(qn, jn, y, r);
    }, Ln = F3(function(r, n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var e = t.d, u = r, a = A3(r, t.b, t.c, A3(Ln, r, n, t.e));
            r = u, n = a, t = e;
        }
    }), Fn = function(r) {
        return A3(Ln, F3(function(r, n, t) {
            return A2(jn, p(r, n), t);
        }), y, r);
    }, _n = 1, Hn = 2, Nn = 0, On = function(r) {
        return {
            $: 1,
            a: r
        };
    }, Bn = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Gn = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), zn = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), Dn = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Wn = function(r) {
        return {
            $: 2,
            a: r
        };
    }, Un = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Vn = {
        $: 1
    }, Pn = G, Mn = F2(function(r, n) {
        return A2(F, r, I(n));
    }), Kn = F2(function(r, n) {
        return S(A2(L, r, n));
    }), Yn = F3(function(r, n, t) {
        for(;;){
            if (!t.b) return n;
            var e = t.b, u = r, a = A2(r, t.a, n);
            r = u, n = a, t = e;
        }
    }), Xn = function(r) {
        return A3(Yn, F2(function(r, n) {
            return n + 1;
        }), 0, r);
    }, Zn = R, Qn = F3(function(r, n, t) {
        for(;;){
            if (d(r, n) >= 1) return t;
            var e = r, u = n - 1, a = A2(jn, n, t);
            r = e, n = u, t = a;
        }
    }), rt = F2(function(r, n) {
        return A3(Qn, r, n, y);
    }), nt = F2(function(r, n) {
        return A3(Zn, r, A2(rt, 0, Xn(n) - 1), n);
    }), tt = function(r) {
        return A3(Yn, jn, y, r);
    }, et = 32, ut = F4(function(r, n, t, e) {
        return {
            $: 0,
            a: r,
            b: n,
            c: t,
            d: e
        };
    }), at = [], it = E, ot = F2(function(r, n) {
        return C(n) / C(r);
    }), ft = it(A2(ot, 2, et)), ct = A4(ut, 0, ft, at, at), st = t, lt = function(r) {
        return {
            $: 1,
            a: r
        };
    }, bt = A, vt = function(r) {
        return r.length;
    }, dt = F2(function(r, n) {
        return d(r, n) > 0 ? r : n;
    }), ht = function(r) {
        return {
            $: 0,
            a: r
        };
    }, gt = e, pt = F2(function(r, n) {
        for(;;){
            var t = A2(gt, et, r), e = t.b, u = A2(jn, ht(t.a), n);
            if (!e.b) return tt(u);
            r = e, n = u;
        }
    }), $t = function(r) {
        return r.a;
    }, mt = F2(function(r, n) {
        for(;;){
            var t = it(n / et);
            if (1 === t) return A2(gt, et, r).a;
            r = A2(pt, r, y), n = t;
        }
    }), wt = F2(function(r, n) {
        if (n.c) {
            var t = n.c * et, e = bt(A2(ot, et, t - 1)), u = r ? tt(n.g) : n.g, a = A2(mt, u, n.c);
            return A4(ut, vt(n.f) + t, A2(dt, 5, e * ft), a, n.f);
        }
        return A4(ut, vt(n.f), ft, at, n.f);
    }), yt = F5(function(r, n, t, e, u) {
        for(;;){
            if (0 > n) return A2(wt, !1, {
                g: e,
                c: t / et | 0,
                f: u
            });
            var a = lt(A3(st, et, n, r));
            n -= et, e = A2(jn, a, e);
        }
    }), xt = F2(function(r, n) {
        if (r > 0) {
            var t = r % et;
            return A5(yt, n, r - t - et, r, y, A3(st, t, r - t, n));
        }
        return ct;
    }), kt = function(r) {
        return !r.$;
    }, St = M, It = K, Rt = Y, Jt = function(r) {
        return {
            $: 0,
            a: r
        };
    }, Et = function(r) {
        switch(r.$){
            case 0:
                return 0;
            case 1:
                return 1;
            case 2:
                return 2;
            default:
                return 3;
        }
    }, At = function(r) {
        return r;
    }, jt = At, Ct = F6(function(r, n, t, e, u, a) {
        return {
            ak: a,
            aF: n,
            ae: e,
            aL: t,
            aO: r,
            aP: u
        };
    }), qt = H, Tt = _, Lt = F2(function(r, n) {
        return 1 > r ? n : A3(Tt, r, n.length, n);
    }), Ft = B, _t = function(r) {
        return "" === r;
    }, Ht = F2(function(r, n) {
        return 1 > r ? "" : A3(Tt, 0, r, n);
    }), Nt = function(r) {
        for(var n = 0, t = r.charCodeAt(0), e = 43 == t || 45 == t ? 1 : 0, u = e; r.length > u; ++u){
            var a = r.charCodeAt(u);
            if (48 > a || a > 57) return Vn;
            n = 10 * n + a - 48;
        }
        return u == e ? Vn : Un(45 == t ? -n : n);
    }, Ot = F5(function(r, n, t, e, u) {
        if (_t(u) || A2(qt, "@", u)) return Vn;
        var a = A2(Ft, ":", u);
        if (a.b) {
            if (a.b.b) return Vn;
            var i = a.a, o = Nt(A2(Lt, i + 1, u));
            if (1 === o.$) return Vn;
            var f = o;
            return Un(A6(Ct, r, A2(Ht, i, u), f, n, t, e));
        }
        return Un(A6(Ct, r, u, Vn, n, t, e));
    }), Bt = F4(function(r, n, t, e) {
        if (_t(e)) return Vn;
        var u = A2(Ft, "/", e);
        if (u.b) {
            var a = u.a;
            return A5(Ot, r, A2(Lt, a, e), n, t, A2(Ht, a, e));
        }
        return A5(Ot, r, "/", n, t, e);
    }), Gt = F3(function(r, n, t) {
        if (_t(t)) return Vn;
        var e = A2(Ft, "?", t);
        if (e.b) {
            var u = e.a;
            return A4(Bt, r, Un(A2(Lt, u + 1, t)), n, A2(Ht, u, t));
        }
        return A4(Bt, r, Vn, n, t);
    }), zt = F2(function(r, n) {
        if (_t(n)) return Vn;
        var t = A2(Ft, "#", n);
        if (t.b) {
            var e = t.a;
            return A3(Gt, r, Un(A2(Lt, e + 1, n)), A2(Ht, e, n));
        }
        return A3(Gt, r, Vn, n);
    }), Dt = N, Wt = function(r) {
        return A2(Dt, "http://", r) ? A2(zt, 0, A2(Lt, 7, r)) : A2(Dt, "https://", r) ? A2(zt, 1, A2(Lt, 8, r)) : Vn;
    }, Ut = function() {
        for(;;);
    }, Vt = fr, Pt = Vt(0), Mt = F4(function(r, n, t, e) {
        if (e.b) {
            var u = e.a, a = e.b;
            if (a.b) {
                var i = a.a, o = a.b;
                if (o.b) {
                    var f = o.a, c = o.b;
                    if (c.b) {
                        var s = c.b;
                        return A2(r, u, A2(r, i, A2(r, f, A2(r, c.a, t > 500 ? A3(Yn, r, n, tt(s)) : A4(Mt, r, n, t + 1, s)))));
                    }
                    return A2(r, u, A2(r, i, A2(r, f, n)));
                }
                return A2(r, u, A2(r, i, n));
            }
            return A2(r, u, n);
        }
        return n;
    }), Kt = F3(function(r, n, t) {
        return A4(Mt, r, n, 0, t);
    }), Yt = F2(function(r, n) {
        return A3(Kt, F2(function(n, t) {
            return A2(jn, r(n), t);
        }), y, n);
    }), Xt = sr, Zt = F2(function(r, n) {
        return A2(Xt, function(n) {
            return Vt(r(n));
        }, n);
    }), Qt = F3(function(r, n, t) {
        return A2(Xt, function(n) {
            return A2(Xt, function(t) {
                return Vt(A2(r, n, t));
            }, t);
        }, n);
    }), re = function(r) {
        return A3(Kt, Qt(jn), Vt(y), r);
    }, ne = Sr, te = F2(function(r, n) {
        var t = n;
        return dr(A2(Xt, ne(r), t));
    });
    yr.Task = xr(Pt, F3(function(r, n) {
        return A2(Zt, function() {
            return 0;
        }, re(A2(Yt, te(r), n)));
    }), F3(function() {
        return Vt(0);
    }), F2(function(r, n) {
        return A2(Zt, r, n);
    }));
    var ee = Rr("Task"), ue = F2(function(r, n) {
        return ee(A2(Zt, r, n));
    }), ae = V, ie = {
        $: 0
    }, oe = function(r) {
        return {
            $: 0,
            a: r
        };
    }, fe = function(r) {
        return {
            $: 2,
            m: r
        };
    }, ce = kn, se = Tr("renderImage", At), le = o, be = F3(function(r, n, t) {
        var e = t.c, u = t.d, a = F2(function(n, t) {
            return A3(le, n.$ ? r : a, t, n.a);
        });
        return A3(le, r, A3(le, a, n, e), u);
    }), ve = F2(function(r, n) {
        return A3(be, or(r), [], n);
    }), de = ar, he = ar, ge = F2(function(r, n) {
        return A3(Yn, or(r), [], n);
    }), pe = function(r) {
        return A2(ge, he, r);
    }, $e = function(r) {
        return A3(Yn, F2(function(r, n) {
            return A3(ir, r.a, r.b, n);
        }), {}, r);
    }, me = function(r) {
        return $e(S([
            p("tl", pe(r.I)),
            p("tr", pe(r.J)),
            p("bl", pe(r.R)),
            p("br", pe(r.S))
        ]));
    }, we = function(r) {
        return se(function(r) {
            var n;
            return $e(S([
                p("level", he(r.aG)),
                p("initialVariables", (n = r.y, A2(ve, de, n))),
                p("permutations", me(r.a))
            ]));
        }(r));
    }, ye = {
        $: -2
    }, xe = ye, ke = F2(function(r, n) {
        return n.$ ? Vn : Un(r(n.a));
    }), Se = F5(function(r, n, t, e, u) {
        return {
            $: -1,
            a: r,
            b: n,
            c: t,
            d: e,
            e: u
        };
    }), Ie = F5(function(r, n, t, e, u) {
        if (-1 !== u.$ || u.a) {
            if (-1 !== e.$ || e.a || -1 !== e.d.$ || e.d.a) return A5(Se, r, n, t, e, u);
            var a = e.d;
            return i = e.e, A5(Se, 0, e.b, e.c, A5(Se, 1, a.b, a.c, a.d, a.e), A5(Se, 1, n, t, i, u));
        }
        var i, o = u.b, f = u.c, c = u.d, s = u.e;
        return -1 !== e.$ || e.a ? A5(Se, r, o, f, A5(Se, 0, n, t, e, c), s) : A5(Se, 0, n, t, A5(Se, 1, e.b, e.c, e.d, i = e.e), A5(Se, 1, o, f, c, s));
    }), Re = h, Je = F3(function(r, n, t) {
        if (-2 === t.$) return A5(Se, 0, r, n, ye, ye);
        var e = t.a, u = t.b, a = t.c, i = t.d, o = t.e;
        switch(A2(Re, r, u)){
            case 0:
                return A5(Ie, e, u, a, A3(Je, r, n, i), o);
            case 1:
                return A5(Se, e, u, n, i, o);
            default:
                return A5(Ie, e, u, a, i, A3(Je, r, n, o));
        }
    }), Ee = F3(function(r, n, t) {
        var e = A3(Je, r, n, t);
        return -1 !== e.$ || e.a ? e : A5(Se, 1, e.b, e.c, e.d, e.e);
    }), Ae = function(r) {
        return A3(Yn, F2(function(r, n) {
            return A3(Ee, r.a, r.b, n);
        }), xe, r);
    }, je = function(r) {
        return A2(Mn, ",", A2(Yt, Pn, r));
    }, Ce = function(r) {
        var n;
        return Ae(S([
            p("level", S([
                Pn(r.aG)
            ])),
            p("colors", S([
                (n = r.y, A2(Mn, ",", Tn(n)))
            ])),
            p("tl", S([
                je(r.a.I)
            ])),
            p("tr", S([
                je(r.a.J)
            ])),
            p("bl", S([
                je(r.a.R)
            ])),
            p("br", S([
                je(r.a.S)
            ])),
            p("sym", S([
                r.ag ? "t" : "f"
            ])),
            p("v", S([
                "0"
            ]))
        ]));
    }, qe = T, Te = q, Le = function(r) {
        return A2(Te, r, "");
    }, Fe = function(r) {
        switch(r){
            case "/":
                return "%2F";
            case "?":
                return "%3F";
            case "#":
                return "%23";
            default:
                return Le(r);
        }
    }, _e = function(r) {
        switch(r){
            case "=":
                return "%3D";
            case "&":
                return "%26";
            case "#":
                return "%23";
            default:
                return Le(r);
        }
    }, He = function(r) {
        switch(r){
            case 0:
                return Fe;
            case 1:
                return _e;
            default:
                return Le;
        }
    }, Ne = function(r) {
        switch(r){
            case 0:
            default:
                return !1;
            case 1:
                return !0;
        }
    }, Oe = F2(function(r, n) {
        switch(n){
            case "\0":
                return "%00";
            case "\x01":
                return "%01";
            case "\x02":
                return "%02";
            case "\x03":
                return "%03";
            case "\x04":
                return "%04";
            case "\x05":
                return "%05";
            case "\x06":
                return "%06";
            case "\x07":
                return "%07";
            case "\b":
                return "%08";
            case "	":
                return "%09";
            case "\n":
                return "%0A";
            case "\v":
                return "%0B";
            case "\f":
                return "%0C";
            case "\r":
                return "%0D";
            case "\x0e":
                return "%0E";
            case "\x0f":
                return "%0F";
            case "\x10":
                return "%10";
            case "\x11":
                return "%11";
            case "\x12":
                return "%12";
            case "\x13":
                return "%13";
            case "\x14":
                return "%14";
            case "\x15":
                return "%15";
            case "\x16":
                return "%16";
            case "\x17":
                return "%17";
            case "\x18":
                return "%18";
            case "\x19":
                return "%19";
            case "\x1a":
                return "%1A";
            case "\x1b":
                return "%1B";
            case "\x1c":
                return "%1C";
            case "\x1d":
                return "%1D";
            case "\x1e":
                return "%1E";
            case "\x1f":
                return "%1F";
            case " ":
                return Ne(r) ? "+" : "%20";
            case "%":
                return "%25";
            case "+":
                return Ne(r) ? "%2B" : "+";
            case "\xa0":
                return "%C2%A0";
            case "\u1680":
                return "%E1%9A%80";
            case "\u2000":
                return "%E2%80%80";
            case "\u2001":
                return "%E2%80%81";
            case "\u2002":
                return "%E2%80%82";
            case "\u2003":
                return "%E2%80%83";
            case "\u2004":
                return "%E2%80%84";
            case "\u2005":
                return "%E2%80%85";
            case "\u2006":
                return "%E2%80%86";
            case "\u2007":
                return "%E2%80%87";
            case "\u2008":
                return "%E2%80%88";
            case "\u2009":
                return "%E2%80%89";
            case "\u200A":
                return "%E2%80%8A";
            case "\u2028":
                return "%E2%80%A8";
            case "\u2029":
                return "%E2%80%A9";
            case "\u202F":
                return "%E2%80%AF";
            case "\u205F":
                return "%E2%81%9F";
            case "\u3000":
                return "%E3%80%80";
            case "\uFEFF":
                return "%EF%BB%BF";
            default:
                return A2(He, r, n);
        }
    }), Be = F2(function(r, n) {
        return A3(qe, F2(function(n, t) {
            return w(A2(Oe, r, n), t);
        }), "", n);
    }), Ge = F2(function(r, n) {
        return n.b ? A3(Kt, jn, n, r) : r;
    }), ze = function(r) {
        return A3(Kt, Ge, y, r);
    }, De = F2(function(r, n) {
        return ze(A2(Yt, r, n));
    }), We = F3(function(r, n, t) {
        for(;;){
            if (-2 === t.$) return n;
            var e = t.e, u = r, a = A3(r, t.b, t.c, A3(We, r, n, t.d));
            r = u, n = a, t = e;
        }
    }), Ue = F2(function(r, n) {
        return A3(We, F3(function(n, t, e) {
            return A2(r, n, t) ? A3(Ee, n, t, e) : e;
        }), xe, n);
    }), Ve = function(r) {
        var n = r.a;
        return A2(Yt, function(r) {
            return !_t(n) && _t(r) ? A2(Be, 1, n) : A2(Be, 1, n) + "=" + A2(Be, 1, r);
        }, r.b);
    }, Pe = F2(function(r, n) {
        return n.$ ? r : n.a;
    }), Me = function(r) {
        var n, t, e, u, a, i = function() {
            if (r.$) {
                var n = r.a, t = function() {
                    switch(n){
                        case 0:
                            return "/tutorial/1";
                        case 1:
                            return "/tutorial/2";
                        case 2:
                            return "/tutorial/3";
                        case 3:
                            return "/tutorial/4";
                        default:
                            return "/tutorial/end";
                    }
                }();
                return {
                    ak: Un(t),
                    ae: S([
                        "fraquilt",
                        ""
                    ]),
                    ap: xe
                };
            }
            var e = r.a;
            return {
                ak: Vn,
                ae: S([
                    "fraquilt",
                    ""
                ]),
                ap: A2(Pe, xe, A2(ke, Ce, e))
            };
        }();
        return w((a = (n = i).ae, "/" + A2(Mn, "/", A2(Yt, Be(0), a))), w((e = n.ap, -2 === (u = A2(Ue, F2(function(r, n) {
            return !!n.b;
        }), e)).$ ? "" : "?" + A2(Mn, "&", A2(De, Ve, Fn(u)))), (t = n.ak).$ ? "" : "#" + A2(Be, 2, t.a)));
    }, Ke = F2(function(r, n) {
        return fe(S([
            we(n),
            A2(ce, r, Me(oe(Un(n))))
        ]));
    }), Ye = F3(function(r, n, t) {
        for(;;){
            var e = A2(gt, et, r), u = e.a, a = e.b;
            if (0 > d(vt(u), et)) return A2(wt, !0, {
                g: n,
                c: t,
                f: u
            });
            r = a, n = A2(jn, lt(u), n), t += 1;
        }
    }), Xe = function(r) {
        return r.b ? A3(Ye, r, y, 0) : ct;
    }, Ze = Xe(S([
        "#ffffff",
        "#000000",
        "#ff0000",
        "#00ff00",
        "#0000ff"
    ])), Qe = {
        $: 4
    }, ru = function(r) {
        return {
            $: 0,
            a: r
        };
    }, nu = function(r) {
        return {
            $: 1,
            a: r
        };
    }, tu = function(r) {
        return {
            $: 2,
            a: r
        };
    }, eu = function(r) {
        return {
            $: 3,
            a: r
        };
    }, uu = Xe(S([
        "#ffffff",
        "#808080",
        "#000000"
    ])), au = function(r) {
        switch(r){
            case 0:
                return ru({
                    b: uu,
                    ac: !1
                });
            case 1:
                return nu({
                    b: uu,
                    t: !1,
                    U: S([
                        1,
                        2,
                        0
                    ]),
                    G: Vn
                });
            case 2:
                return tu({
                    b: uu,
                    t: !1,
                    a: {
                        R: S([
                            2,
                            1,
                            0
                        ]),
                        S: S([
                            1,
                            0,
                            2
                        ]),
                        I: S([
                            0,
                            1,
                            2
                        ]),
                        J: S([
                            2,
                            0,
                            1
                        ])
                    },
                    H: ie,
                    V: !0
                });
            case 3:
                return eu({
                    b: uu,
                    t: !1,
                    a: {
                        R: S([
                            2,
                            1,
                            0
                        ]),
                        S: S([
                            1,
                            0,
                            2
                        ]),
                        I: S([
                            0,
                            1,
                            2
                        ]),
                        J: S([
                            2,
                            0,
                            1
                        ])
                    },
                    H: ie,
                    V: !0
                });
            default:
                return Qe;
        }
    }, iu = F2(function(r, n) {
        return {
            $: 0,
            a: r,
            b: n
        };
    }), ou = function(r) {
        var n = r.b;
        return A2(iu, 1664525 * r.a + n >>> 0, n);
    }, fu = function(r) {
        var n = ou(A2(iu, 0, 1013904223));
        return ou(A2(iu, n.a + r >>> 0, n.b));
    }, cu = fe(y), su = function(r) {
        return {
            $: 1,
            a: r
        };
    }, lu = function(r) {
        return A2(Pe, r, function(r) {
            try {
                return Un(decodeURIComponent(r));
            } catch (r) {
                return Vn;
            }
        }(r));
    }, bu = F2(function(r, n) {
        return 1 > r ? n : A3(Tt, 0, -r, n);
    }), vu = O, du = F3(function(r, n, t) {
        return n(r(t));
    }), hu = F2(function(r, n) {
        return Un(A2(jn, r, A2(Pe, y, n)));
    }), gu = A2(du, A2(F3(function(r, n, t) {
        return A2(Mn, n, A2(Kn, r, t));
    }), "+", " "), lu), pu = F2(function(r, n) {
        r: for(;;){
            if (-2 === n.$) return Vn;
            var t = n.c, e = n.d, u = n.e;
            switch(A2(Re, r, n.b)){
                case 0:
                    n = e;
                    continue r;
                case 1:
                    return Un(t);
                default:
                    n = u;
                    continue r;
            }
        }
    }), $u = function(r) {
        if (-1 === r.$ && -1 === r.d.$ && -1 === r.e.$) {
            if (-1 !== r.e.d.$ || r.e.d.a) {
                var n = r.d, t = r.e;
                return i = t.b, o = t.c, e = t.d, s = t.e, A5(Se, 1, r.b, r.c, A5(Se, 0, n.b, n.c, n.d, n.e), A5(Se, 0, i, o, e, s));
            }
            var e, u = r.d, a = r.e, i = a.b, o = a.c, f = (e = a.d).d, c = e.e, s = a.e;
            return A5(Se, 0, e.b, e.c, A5(Se, 1, r.b, r.c, A5(Se, 0, u.b, u.c, u.d, u.e), f), A5(Se, 1, i, o, c, s));
        }
        return r;
    }, mu = function(r) {
        if (-1 === r.$ && -1 === r.d.$ && -1 === r.e.$) {
            if (-1 !== r.d.d.$ || r.d.d.a) {
                var n = r.d, t = r.e;
                return c = t.b, s = t.c, l = t.d, b = t.e, A5(Se, 1, e = r.b, u = r.c, A5(Se, 0, n.b, n.c, n.d, o = n.e), A5(Se, 0, c, s, l, b));
            }
            var e = r.b, u = r.c, a = r.d, i = a.d, o = a.e, f = r.e, c = f.b, s = f.c, l = f.d, b = f.e;
            return A5(Se, 0, a.b, a.c, A5(Se, 1, i.b, i.c, i.d, i.e), A5(Se, 1, e, u, o, A5(Se, 0, c, s, l, b)));
        }
        return r;
    }, wu = F7(function(r, n, t, e, u, a, i) {
        if (-1 !== a.$ || a.a) {
            r: for(;;){
                if (-1 === i.$ && 1 === i.a) {
                    if (-1 === i.d.$) {
                        if (1 === i.d.a) return mu(n);
                        break r;
                    }
                    return mu(n);
                }
                break r;
            }
            return n;
        }
        return A5(Se, t, a.b, a.c, a.d, A5(Se, 0, e, u, a.e, i));
    }), yu = function(r) {
        if (-1 === r.$ && -1 === r.d.$) {
            var n = r.a, t = r.b, e = r.c, u = r.d, a = u.d, i = r.e;
            if (1 === u.a) {
                if (-1 !== a.$ || a.a) {
                    var o = $u(r);
                    if (-1 === o.$) {
                        var f = o.e;
                        return A5(Ie, o.a, o.b, o.c, yu(o.d), f);
                    }
                    return ye;
                }
                return A5(Se, n, t, e, yu(u), i);
            }
            return A5(Se, n, t, e, yu(u), i);
        }
        return ye;
    }, xu = F2(function(r, n) {
        if (-2 === n.$) return ye;
        var t = n.a, e = n.b, u = n.c, a = n.d, i = n.e;
        if (0 > d(r, e)) {
            if (-1 === a.$ && 1 === a.a) {
                var o = a.d;
                if (-1 !== o.$ || o.a) {
                    var f = $u(n);
                    if (-1 === f.$) {
                        var c = f.e;
                        return A5(Ie, f.a, f.b, f.c, A2(xu, r, f.d), c);
                    }
                    return ye;
                }
                return A5(Se, t, e, u, A2(xu, r, a), i);
            }
            return A5(Se, t, e, u, A2(xu, r, a), i);
        }
        return A2(ku, r, A7(wu, r, n, t, e, u, a, i));
    }), ku = F2(function(r, n) {
        if (-1 === n.$) {
            var t = n.a, e = n.b, u = n.c, a = n.d, i = n.e;
            if (b(r, e)) {
                var o = function(r) {
                    for(;;){
                        if (-1 !== r.$ || -1 !== r.d.$) return r;
                        r = r.d;
                    }
                }(i);
                return -1 === o.$ ? A5(Ie, t, o.b, o.c, a, yu(i)) : ye;
            }
            return A5(Ie, t, e, u, a, A2(xu, r, i));
        }
        return ye;
    }), Su = F2(function(r, n) {
        var t = A2(xu, r, n);
        return -1 !== t.$ || t.a ? t : A5(Se, 1, t.b, t.c, t.d, t.e);
    }), Iu = F3(function(r, n, t) {
        var e = n(A2(pu, r, t));
        return e.$ ? A2(Su, r, t) : A3(Ee, r, e.a, t);
    }), Ru = F2(function(r, n) {
        var t = A2(Kn, "=", r);
        if (t.b) {
            if ("" !== t.a || t.b.b) {
                var e = t.b;
                return A3(Iu, gu(t.a), hu(gu(A2(Mn, "=", e))), n);
            }
            return n;
        }
        return n;
    }), Ju = A2(du, Kn("&"), A2(Kt, Ru, xe)), Eu = F2(function(r, n) {
        return n.$ ? Vn : r(n.a);
    }), Au = function(r) {
        return Xe(A2(Kn, ",", r));
    }, ju = F2(function(r, n) {
        for(;;){
            if (!r.b) return Un(tt(n));
            var t = r.a;
            if (t.$) return Vn;
            r = r.b, n = A2(jn, t.a, n);
        }
    }), Cu = function(r) {
        return A2(ju, A2(Yt, Nt, A2(Kn, ",", r)), y);
    }, qu = function(r) {
        return r.b ? Un(r.a) : Vn;
    }, Tu = F4(function(r, n, t, e) {
        return 1 === n.$ || 1 === t.$ || 1 === e.$ ? Vn : Un(A3(r, n.a, t.a, e.a));
    }), Lu = F5(function(r, n, t, e, u) {
        return 1 === n.$ || 1 === t.$ || 1 === e.$ || 1 === u.$ ? Vn : Un(A4(r, n.a, t.a, e.a, u.a));
    }), Fu = function(r) {
        var n = function(r) {
            var n, t, e;
            return {
                ak: A2(ke, lu, r.ak),
                ae: (n = r.ae, e = function(r) {
                    return A2(vu, "/", r) ? A2(bu, 1, r) : r;
                }(A2(Dt, "/", t = n) ? A2(Lt, 1, t) : t), _t(e) ? y : A2(Yt, lu, A2(Kn, "/", e))),
                ap: A2(Pe, xe, A2(ke, Ju, r.aP))
            };
        }(m(r, {
            ae: A2(Pe, "", r.ak)
        })), t = n.ae;
        r: for(; t.b && "tutorial" === t.a && t.b.b && !t.b.b.b;)switch(t.b.a){
            case "1":
                return su(0);
            case "2":
                return su(1);
            case "3":
                return su(2);
            case "4":
                return su(3);
            case "end":
                return su(4);
            default:
                break r;
        }
        return oe(function(r) {
            var n, t = !(n = A2(Eu, qu, A2(pu, "sym", r))).$ && "t" === n.a, e = function(n) {
                return A2(Eu, Cu, A2(Eu, qu, A2(pu, n, r)));
            }, u = A5(Lu, F4(function(r, n, t, e) {
                return {
                    R: t,
                    S: e,
                    I: r,
                    J: n
                };
            }), e("tl"), e("tr"), e("bl"), e("br"));
            return A4(Tu, F3(function(r, n, e) {
                return {
                    y: n,
                    aG: r,
                    a: e,
                    ag: t
                };
            }), A2(Eu, Nt, A2(Eu, qu, A2(pu, "level", r))), A2(ke, Au, A2(Eu, qu, A2(pu, "colors", r))), u);
        }(n.ap));
    }, _u = F3(function(r, n, t) {
        var e = n, u = t;
        return function(n) {
            var t = e(n), a = t.a, i = u(t.b), o = i.b;
            return p(A2(r, a, i.a), o);
        };
    }), Hu = function(r) {
        var n = r.a, t = 277803737 * (n ^ n >>> 4 + (n >>> 28));
        return (t >>> 22 ^ t) >>> 0;
    }, Nu = F2(function(r, n) {
        return function(t) {
            var e = 0 > d(r, n) ? p(r, n) : p(n, r), u = e.a, a = e.b - u + 1;
            if (a - 1 & a) {
                var i = (-a >>> 0) % a >>> 0;
                return function(r) {
                    for(;;){
                        var n = Hu(r), t = ou(r);
                        if (d(n, i) >= 0) return p(n % a + u, t);
                        r = t;
                    }
                }(t);
            }
            return p(((a - 1 & Hu(t)) >>> 0) + u, ou(t));
        };
    }), Ou = A2(Nu, -2147483648, 2147483647), Bu = F4(function(r, n, t, e) {
        var u = n, a = t, i = e;
        return function(n) {
            var t = u(n), e = t.a, o = a(t.b), f = o.a, c = i(o.b), s = c.b;
            return p(A3(r, e, f, c.a), s);
        };
    }), Gu = F2(function(r, n) {
        return r(n);
    }), zu = function(r) {
        var n = F3(function(r, n, t) {
            return ou(A2(iu, r, (1 | n ^ t) >>> 0));
        }), t = A2(Nu, 0, 4294967295);
        return A2(Gu, A4(Bu, n, t, t, t), r);
    }, Du = F2(function(r, n) {
        var t = n;
        return function(n) {
            var e = t(n), u = e.b;
            return p(r(e.a), u);
        };
    }), Wu = function(r) {
        return r.b;
    }, Uu = J, Vu = function(r) {
        var n;
        return n = A2(rt, 0, r - 1), A2(Du, function(r) {
            return A2(Yt, $t, A2(Uu, Wu, A3(Yn, F2(function(r, n) {
                var t = n.a, e = A2(Gu, Ou, n.b), u = e.b;
                return p(A2(jn, p(r, e.a), t), u);
            }), p(y, r), n).a));
        }, zu);
    }, Pu = function(r) {
        return A3(_u, F2(function(r, n) {
            return {
                R: n,
                S: r,
                I: r,
                J: n
            };
        }), Vu(r), Vu(r));
    }, Mu = F3(function(r, n, t) {
        var e = F2(function(n, e) {
            var u = function() {
                if (1 === n.$) {
                    var t = A2(Gu, Pu(5), fu(r.q));
                    return {
                        q: t.b,
                        e: {
                            y: Ze,
                            aG: 9,
                            a: t.a,
                            ag: !0
                        }
                    };
                }
                var e = n.a;
                return {
                    q: fu(r.q),
                    e: e
                };
            }();
            return {
                p: t,
                q: u.q,
                H: ie,
                e: u.e,
                w: e,
                L: r.L
            };
        }), u = Fu(n);
        if (1 === u.$) return p(A2(e, Vn, Un(au(u.a))), cu);
        var a = A2(e, u.a, Vn);
        return p(a, A2(Ke, t, a.e));
    }), Ku = D, Yu = F2(function(r, n) {
        return {
            $: 12,
            a: r,
            b: n
        };
    }), Xu = F3(function(r, n, t) {
        return {
            $: 0,
            a: r,
            b: n,
            c: t
        };
    }), Zu = F2(function(r, n) {
        return {
            aK: n,
            aV: r
        };
    }), Qu = Vt(A2(Zu, y, xe)), ra = function(r) {
        return p(w(r.a ? "w_" : "d_", r.b), r);
    }, na = function(r) {
        return cr(function(n) {
            var t = r.f;
            2 === t.$ && t.c && t.c(), r.f = null, n(fr(g));
        });
    }, ta = F6(function(r, n, t, e, u, a) {
        var i = A3(We, F3(function(e, u, a) {
            r: for(;;){
                var i = a.a, o = a.b;
                if (i.b) {
                    var f = i.a, c = f.a, s = f.b, l = i.b;
                    if (0 > d(c, e)) {
                        a = p(l, A3(r, c, s, o));
                        continue r;
                    }
                    return d(c, e) > 0 ? p(i, A3(t, e, u, o)) : p(l, A4(n, c, s, u, o));
                }
                return p(i, A3(t, e, u, o));
            }
        }), p(Fn(e), a), u), o = i.a, f = i.b;
        return A3(Yn, F2(function(n, t) {
            return A3(r, n.a, n.b, t);
        }), f, o);
    }), ea = F2(function(r, n) {
        return {
            aD: n,
            p: r
        };
    }), ua = Ir, aa = F3(function(r, n, t) {
        return A2(Zt, function(r) {
            return p(n, r);
        }, A3(Jn, t.a ? Rn : In, t.b, function(t) {
            return A2(ua, r, A2(ea, n, t));
        }));
    }), ia = F2(function(r, n) {
        return A3(We, Ee, n, r);
    }), oa = F3(function(r, n, t) {
        var e = F3(function(n, t, e) {
            var u = e.c;
            return $(e.a, e.b, A2(jn, A3(aa, r, n, t), u));
        }), u = F3(function(r, n, t) {
            var e = t.b, u = t.c;
            return $(A2(jn, n, t.a), e, u);
        }), a = F4(function(r, n, t, e) {
            var u = e.c;
            return $(e.a, A3(Ee, r, n, e.b), u);
        }), i = A2(Yt, ra, n), o = A6(ta, u, a, e, t.aK, Ae(i), $(y, xe, y)), f = o.b, c = o.c;
        return A2(Xt, function(r) {
            return Vt(A2(Zu, i, A2(ia, f, Ae(r))));
        }, A2(Xt, function() {
            return re(c);
        }, re(A2(Yt, na, o.a))));
    }), fa = F3(function(r, n, t) {
        var e = r(n);
        return e.$ ? t : A2(jn, e.a, t);
    }), ca = F2(function(r, n) {
        return A3(Kt, fa(r), y, n);
    });
    yr["Browser.Events"] = xr(Qu, oa, F3(function(r, n, t) {
        var e = n.p, u = n.aD, a = A2(ca, function(r) {
            var n = r.b.c;
            return b(r.a, e) ? A2(En, n, u) : Vn;
        }, t.aV);
        return A2(Xt, function() {
            return Vt(t);
        }, re(A2(Yt, ne(r), a)));
    }), 0, F2(function(r, n) {
        return A3(Xu, n.a, n.b, A2(It, r, n.c));
    }));
    var sa, la, ba, va, da, ha = Rr("Browser.Events"), ga = F3(function(r, n, t) {
        return ha(A3(Xu, r, n, t));
    }), pa = function(r) {
        return {
            $: 3,
            a: r
        };
    }, $a = function(r) {
        return {
            $: 4,
            a: r
        };
    }, ma = {
        $: 0
    }, wa = function(r) {
        return {
            $: 1,
            a: r
        };
    }, ya = function(r) {
        return {
            $: 2,
            a: r
        };
    }, xa = function(r) {
        return {
            $: 11,
            a: r
        };
    }, ka = s, Sa = c, Ia = F2(function(r, n) {
        var t = vt(r), e = et - vt(n.f) - t, u = A3(ka, et, n.f, r);
        return 0 > e ? {
            g: A2(jn, lt(u), n.g),
            c: n.c + 1,
            f: A3(Sa, e, t, r)
        } : e ? {
            g: n.g,
            c: n.c,
            f: u
        } : {
            g: A2(jn, lt(u), n.g),
            c: n.c + 1,
            f: at
        };
    }), Ra = 4294967295 >>> 32 - ft, Ja = i, Ea = function(r) {
        return [
            r
        ];
    }, Aa = u, ja = a, Ca = F4(function(r, n, t, e) {
        var u = Ra & n >>> r;
        if (d(u, vt(e)) > -1) {
            if (5 === r) return A2(Ja, lt(t), e);
            var a = ht(A4(Ca, r - ft, n, t, at));
            return A2(Ja, a, e);
        }
        var i = A2(Aa, u, e);
        if (i.$) return a = ht(A4(Ca, r - ft, n, t, Ea(i))), A3(ja, u, a, e);
        a = ht(A4(Ca, r - ft, n, t, i.a));
        return A3(ja, u, a, e);
    }), qa = F2(function(r, n) {
        var t = n.a, e = n.b, u = n.c, a = vt(n.d), i = vt(r), o = t + (i - a);
        if (b(i, et)) {
            if (d(o >>> ft, 1 << e) > 0) {
                var f = e + ft, c = A4(Ca, f, t, r, Ea(ht(u)));
                return A4(ut, o, f, c, at);
            }
            return A4(ut, o, e, A4(Ca, e, t, r, u), at);
        }
        return A4(ut, o, e, u, r);
    }), Ta = F2(function(r, n) {
        var t = n.d, e = vt(r), u = et - vt(t) - e, a = A2(qa, A3(ka, et, t, r), n);
        return 0 > u ? A2(qa, A3(Sa, u, e, r), a) : a;
    }), La = F2(function(r, n) {
        var t, e = n.c, u = n.d;
        return 1 > d(n.a, 128) ? A2(Ta, u, A3(le, t = F2(function(r, n) {
            return r.$ ? A2(Ta, r.a, n) : A3(le, t, n, r.a);
        }), r, e)) : A2(wt, !0, A2(Ia, u, A3(le, t = F2(function(r, n) {
            return r.$ ? A2(Ia, r.a, n) : A3(le, t, n, r.a);
        }), function(r) {
            var n = r.a, t = r.c, e = r.d, u = F2(function(r, n) {
                return r.$ ? A2(jn, r, n) : A3(le, u, n, r.a);
            });
            return {
                g: A3(le, u, y, t),
                c: n / et | 0,
                f: e
            };
        }(r), e)));
    }), Fa = F2(function(r, n) {
        return A2(xt, r, function() {
            return n;
        });
    }), _a = F2(function(r, n) {
        return A2(La, n, A2(Fa, r, "#000000"));
    }), Ha = function(r) {
        return Xn(r);
    }, Na = F2(function(r, n) {
        var t = Ha(n);
        return A2(Ge, n, A2(rt, t, t + r - 1));
    }), Oa = F3(function(r, n, t) {
        return r(n(t));
    }), Ba = lr, Ga = F2(function(r, n) {
        return ee(A2(Ba, A2(Oa, A2(Oa, Vt, r), On), A2(Xt, A2(Oa, A2(Oa, Vt, r), Dn), n)));
    }), za = function(r) {
        return {
            R: A2(rt, 0, r - 1),
            S: A2(rt, 0, r - 1),
            I: A2(rt, 0, r - 1),
            J: A2(rt, 0, r - 1)
        };
    }, Da = function(r) {
        return r.a;
    }, Wa = function(r) {
        return Da(r);
    }, Ua = F2(function(r, n) {
        r: for(;;){
            if (r > 0) {
                if (n.b) {
                    r -= 1, n = n.b;
                    continue r;
                }
                return n;
            }
            return n;
        }
    }), Va = F3(function(r, n, t) {
        r: for(;;){
            if (r > 0) {
                if (n.b) {
                    var e = n.a;
                    r -= 1, n = n.b, t = A2(jn, e, t);
                    continue r;
                }
                return t;
            }
            return t;
        }
    }), Pa = F2(function(r, n) {
        return tt(A3(Va, r, n, y));
    }), Ma = F3(function(r, n, t) {
        if (n > 0) {
            var e = p(n, t);
            r: for(;;){
                n: for(;;){
                    if (!e.b.b) return t;
                    if (!e.b.b.b) {
                        if (1 === e.a) break r;
                        break n;
                    }
                    switch(e.a){
                        case 1:
                            break r;
                        case 2:
                            var u = e.b;
                            return S([
                                u.a,
                                u.b.a
                            ]);
                        case 3:
                            if (e.b.b.b.b) {
                                var a = e.b, i = a.b;
                                return S([
                                    a.a,
                                    i.a,
                                    i.b.a
                                ]);
                            }
                            break n;
                        default:
                            if (e.b.b.b.b && e.b.b.b.b.b) {
                                var o = e.b, f = o.b, c = f.b, s = c.b, l = s.b;
                                return A2(jn, o.a, A2(jn, f.a, A2(jn, c.a, A2(jn, s.a, r > 1e3 ? A2(Pa, n - 4, l) : A3(Ma, r + 1, n - 4, l)))));
                            }
                            break n;
                    }
                }
                return t;
            }
            return S([
                e.b.a
            ]);
        }
        return y;
    }), Ka = F2(function(r, n) {
        return A3(Ma, 0, r, n);
    }), Ya = F2(function(r, n) {
        return p(A2(Ka, r, n), A2(Ua, r, n));
    }), Xa = function(r) {
        return r.b ? Un(p(r.a, r.b)) : Vn;
    }, Za = F3(function(r, n, t) {
        for(;;){
            if (b(r, n) || 0 > r) return t;
            if (0 >= d(r, n)) {
                var e = A2(Ya, r, t), u = e.a, a = A2(Ya, n - r, e.b), i = a.b, o = p(Xa(a.a), Xa(i));
                if (o.a.$ || o.b.$) return t;
                var f = o.a.a, c = f.a, s = o.b.a, l = s.b;
                return ze(S([
                    u,
                    A2(jn, s.a, f.b),
                    A2(jn, c, l)
                ]));
            }
            var v = r;
            r = n, n = v;
        }
    }), Qa = F4(function(r, n, t, e) {
        switch(r.$){
            case 1:
                var u = A3(Za, r.a, n, e.I);
                return m(e, {
                    S: t ? u : e.S,
                    I: u
                });
            case 2:
                return u = A3(Za, r.a, n, e.J), m(e, {
                    R: t ? u : e.R,
                    J: u
                });
            case 3:
                return m(e, {
                    R: A3(Za, r.a, n, e.R)
                });
            case 4:
                return m(e, {
                    S: A3(Za, r.a, n, e.S)
                });
            default:
                return e;
        }
    }), ri = Tr("makeFullscreen", function() {
        return null;
    }), ni = Jr, ti = F5(function(r, n, t, e, u) {
        var a = n, i = t, o = e, f = u;
        return function(n) {
            var t = a(n), e = t.a, u = i(t.b), c = u.a, s = o(u.b), l = s.a, b = f(s.b), v = b.b;
            return p(A4(r, e, c, l, b.a), v);
        };
    }), ei = function(r) {
        return A5(ti, F4(function(r, n, t, e) {
            return {
                R: t,
                S: e,
                I: r,
                J: n
            };
        }), Vu(r), Vu(r), Vu(r), Vu(r));
    }, ui = function(r) {
        return r >>> 5 << 5;
    }, ai = F2(function(r, n) {
        var t = n.a, e = n.c, u = n.d;
        if (r) {
            if (d(r, ui(t)) > -1) return A4(ut, t - r, ft, at, A3(Sa, r - ui(t), vt(u), u));
            var a = r / et | 0, i = F2(function(r, n) {
                return r.$ ? A2(jn, r.a, n) : A3(Cn, i, n, r.a);
            }), o = A3(Cn, i, S([
                u
            ]), e), f = A2(Ua, a, o);
            if (f.b) {
                var c = f.a, s = f.b, l = {
                    g: y,
                    c: 0,
                    f: A3(Sa, r - a * et, vt(c), c)
                };
                return A2(wt, !0, A3(Yn, Ia, l, s));
            }
            return ct;
        }
        return n;
    }), ii = F4(function(r, n, t, e) {
        for(;;){
            var u = A2(Aa, Ra & t >>> r, e);
            if (u.$) return A3(Sa, 0, Ra & n, u.a);
            r -= ft, e = u.a;
        }
    }), oi = F3(function(r, n, t) {
        for(;;){
            if (1 > d(r, n) || !vt(t)) return t;
            var e = A2(Aa, 0, t);
            if (e.$) return t;
            r -= ft, t = e.a;
        }
    }), fi = F3(function(r, n, t) {
        var e = Ra & n >>> r, u = A2(Aa, e, t);
        if (u.$) return A3(Sa, 0, e, t);
        var a = A3(fi, r - ft, n, u.a);
        return vt(a) ? A3(ja, e, ht(a), A3(Sa, 0, e + 1, t)) : A3(Sa, 0, e, t);
    }), ci = F2(function(r, n) {
        var t = n.a, e = n.b, u = n.c, a = n.d;
        if (b(r, t)) return n;
        if (d(r, ui(t)) > -1) return A4(ut, r, e, u, A3(Sa, 0, Ra & r, a));
        var i = ui(r), o = bt(A2(ot, et, A2(dt, 1, i - 1))), f = A2(dt, 5, o * ft);
        return A4(ut, r, f, A3(oi, e, f, A3(fi, e, i, u)), A4(ii, e, r, i, u));
    }), si = F2(function(r, n) {
        var t = n.a, e = 0 > r ? t + r : r;
        return 0 > e ? 0 : d(e, t) > 0 ? t : e;
    }), li = F3(function(r, n, t) {
        var e = A2(si, n, t), u = A2(si, r, t);
        return d(u, e) > 0 ? ct : A2(ai, u, A2(ci, e, t));
    }), bi = F2(function(r, n) {
        return A3(li, 0, Da(n) - r, n);
    }), vi = F2(function(r, n) {
        return 0 > r ? Vn : qu(A2(Ua, r, n));
    }), di = F2(function(r, n) {
        return p(r, n);
    }), hi = F2(function(r, n) {
        var t = Ha(n), e = Ae(A2(ca, function(r) {
            return A2(ke, di(r), A2(vi, r, n));
        }, A2(rt, t - r, t)));
        return A2(Yt, function(r) {
            return A2(Pe, r, A2(pu, r, e));
        }, A2(Ka, t - r, n));
    }), gi = F4(function(r, n, t, e) {
        var u = Ra & n >>> r, a = A2(Aa, u, e);
        return A3(ja, u, a.$ ? lt(A3(ja, Ra & n, t, a.a)) : ht(A4(gi, r - ft, n, t, a.a)), e);
    }), pi = F3(function(r, n, t) {
        var e = t.a, u = t.b, a = t.c, i = t.d;
        return 0 > r || d(r, e) > -1 ? t : d(r, ui(e)) > -1 ? A4(ut, e, u, a, A3(ja, Ra & r, n, i)) : A4(ut, e, u, A4(gi, u, r, n, a), i);
    }), $i = F3(function(r, n, t) {
        return A3(pi, r, n, t);
    }), mi = An, wi = F2(function(r, n) {
        return 1 === r.$ ? n : n + ":" + Pn(r.a);
    }), yi = F3(function(r, n, t) {
        return 1 === n.$ ? t : w(t, w(r, n.a));
    }), xi = F2(function(r, n) {
        switch(r.$){
            case 0:
                return p(n, cu);
            case 1:
                var t = r.a, e = r.b;
                switch(n.$){
                    case 0:
                        return p(ru(m(i = n.a, {
                            b: A3($i, t, e, i.b),
                            ac: !0
                        })), cu);
                    case 1:
                        return p(nu(m(i = n.a, {
                            b: A3($i, t, e, i.b)
                        })), cu);
                    case 2:
                        return p(tu(m(i = n.a, {
                            b: A3($i, t, e, i.b)
                        })), cu);
                    case 3:
                        return p(eu(m(i = n.a, {
                            b: A3($i, t, e, i.b)
                        })), cu);
                    default:
                        return p(n, cu);
                }
            case 2:
                return t = r.a, p(1 === n.$ ? nu(m(i = n.a, {
                    G: Un(t)
                })) : n, cu);
            case 3:
                var u = r.a, a = (t = r.b, function(r) {
                    return m(r, {
                        H: function() {
                            switch(u){
                                case 0:
                                    return wa(t);
                                case 1:
                                    return ya(t);
                                case 2:
                                    return pa(t);
                                default:
                                    return $a(t);
                            }
                        }()
                    });
                });
                switch(n.$){
                    case 2:
                        return p(tu(a(i = n.a)), cu);
                    case 3:
                        return p(eu(a(i = n.a)), cu);
                    default:
                        return p(n, cu);
                }
            case 4:
                switch(t = r.a, n.$){
                    case 1:
                        return p(nu((o = (i = n.a).G).$ ? i : m(i, {
                            t: !0,
                            U: A3(Za, o.a, t, i.U),
                            G: Vn
                        })), cu);
                    case 2:
                        return p(tu(m(i = n.a, {
                            t: !0,
                            a: A4(Qa, i.H, t, !1, i.a),
                            H: ie
                        })), cu);
                    case 3:
                        return p(eu(m(i = n.a, {
                            a: A4(Qa, i.H, t, !1, i.a),
                            H: ie
                        })), cu);
                    default:
                        return p(n, cu);
                }
            case 5:
                switch(n.$){
                    case 1:
                        return p(nu(m(i = n.a, {
                            G: Vn
                        })), cu);
                    case 2:
                        return p(tu(m(i = n.a, {
                            H: ie
                        })), cu);
                    case 3:
                        return p(eu(m(i = n.a, {
                            H: ie
                        })), cu);
                    default:
                        return p(n, cu);
                }
            default:
                var i;
                return p(2 === n.$ ? tu(m(i = n.a, {
                    V: r.a
                })) : n, cu);
        }
        var o;
    }), ki = F2(function(r, n) {
        var t, e = n.e;
        switch(r.$){
            case 0:
                return p(n, cu);
            case 1:
                var u = Fu(r.a);
                if (1 === u.$) return p(m(n, {
                    w: Un(au(u.a))
                }), A2(Ga, function() {
                    return ma;
                }, A3(mi, "page", 0, 0)));
                if (1 === u.a.$) return p(m(n, {
                    w: Vn
                }), A2(Ke, n.p, e));
                var a = u.a.a;
                return b(a, e) ? p(m(n, {
                    w: Vn
                }), cu) : p(m(n, {
                    e: a,
                    w: Vn
                }), we(a));
            case 2:
                var i = r.a;
                return p(n, i.$ ? (t = i.a, A2(ue, Ut, cr(function() {
                    try {
                        Rn.location = t;
                    } catch (r) {
                        Hr.location.reload(!1);
                    }
                }))) : A2(ce, n.p, function(r) {
                    return A3(yi, "#", r.ak, A3(yi, "?", r.aP, w(A2(wi, r.aL, w(r.aO ? "https://" : "http://", r.aF)), r.ae)));
                }(i.a)));
            case 3:
                var o = A2(Gu, (e.ag ? Pu : ei)(Wa(n.e.y)), n.q), f = o.b, c = m(e, {
                    a: o.a
                });
                return p(m(n, {
                    q: f,
                    e: c
                }), A2(Ke, n.p, c));
            case 4:
                var s = Wa(e.y), l = m(e, {
                    a: za(s)
                });
                return p(m(n, {
                    e: l
                }), A2(Ke, n.p, l));
            case 5:
                return l = m(e, {
                    y: A3($i, y = r.a, r.b, e.y)
                }), p(m(n, {
                    e: l
                }), A2(Ke, n.p, l));
            case 6:
                var v = Nt(r.a);
                return 1 === v.$ ? p(n, cu) : (l = m(e, {
                    aG: v.a
                }), p(m(n, {
                    e: l
                }), A2(Ke, n.p, l)));
            case 7:
                if (2 > (s = r.a)) return p(n, cu);
                var h = n.e.y, g = Wa(h);
                return l = function() {
                    if (b(s, g)) return e;
                    if (d(s, g) > 0) {
                        var r = s - g;
                        return m(e, {
                            y: A2(_a, r, h),
                            a: {
                                R: A2(Na, r, e.a.R),
                                S: A2(Na, r, e.a.S),
                                I: A2(Na, r, e.a.I),
                                J: A2(Na, r, e.a.J)
                            }
                        });
                    }
                    var n = g - s;
                    return m(e, {
                        y: A2(bi, n, h),
                        a: {
                            R: A2(hi, n, e.a.R),
                            S: A2(hi, n, e.a.S),
                            I: A2(hi, n, e.a.I),
                            J: A2(hi, n, e.a.J)
                        }
                    });
                }(), p(m(n, {
                    e: l
                }), A2(Ke, n.p, l));
            case 10:
                return p(m(n, {
                    H: ie
                }), cu);
            case 8:
                var $ = r.a, y = r.b;
                return p(m(n, {
                    H: function() {
                        switch($){
                            case 0:
                                return wa(y);
                            case 1:
                                return ya(y);
                            case 2:
                                return pa(y);
                            default:
                                return $a(y);
                        }
                    }()
                }), cu);
            case 9:
                return l = m(e, {
                    a: A4(Qa, n.H, r.a, e.ag, e.a)
                }), p(m(n, {
                    H: ie,
                    e: l
                }), A2(Ke, n.p, l));
            case 11:
                var x = r.a, k = n.w;
                if (k.$) return p(n, cu);
                var S = A2(xi, x, k.a), I = S.b;
                return p(m(n, {
                    w: Un(S.a)
                }), A2(ni, xa, I));
            case 12:
                return p(m(n, {
                    L: {
                        al: r.b,
                        aZ: r.a
                    }
                }), cu);
            case 13:
                return p(n, ri(0));
            default:
                var R = r.a;
                return l = m(e, {
                    a: R ? {
                        R: e.a.J,
                        S: e.a.I,
                        I: e.a.I,
                        J: e.a.J
                    } : e.a,
                    ag: R
                }), p(m(n, {
                    e: l
                }), A2(Ke, n.p, l));
        }
    }), Si = {
        $: 13
    }, Ii = {
        $: 3
    }, Ri = Gr("button"), Ji = Gr("canvas"), Ei = F2(function(r, n) {
        return A2(Vr, r, de(n));
    }), Ai = Ei("className"), ji = Gr("div"), Ci = Ei("id"), qi = Dr, Ti = qi, Li = Br("http://www.w3.org/2000/svg"), Fi = Li("line"), _i = function(r) {
        return {
            ab: Un("feather feather-" + r),
            af: 24,
            W: "",
            aU: 2,
            ah: "0 0 24 24"
        };
    }, Hi = F2(function(r, n) {
        return {
            i: _i(r),
            k: n
        };
    }), Ni = Pr("points"), Oi = Li("polyline"), Bi = Pr("x1"), Gi = Pr("x2"), zi = Pr("y1"), Di = Pr("y2"), Wi = A2(Hi, "maximize-2", S([
        A2(Oi, S([
            Ni("15 3 21 3 21 9")
        ]), y),
        A2(Oi, S([
            Ni("9 21 3 21 3 15")
        ]), y),
        A2(Fi, S([
            Bi("21"),
            zi("3"),
            Gi("14"),
            Di("10")
        ]), y),
        A2(Fi, S([
            Bi("3"),
            zi("21"),
            Gi("10"),
            Di("14")
        ]), y)
    ])), Ui = Wr, Vi = F2(function(r, n) {
        return A2(Ui, r, {
            $: 0,
            a: n
        });
    }), Pi = function(r) {
        return A2(Vi, "click", Jt(r));
    }, Mi = Ur, Ki = Pr("class"), Yi = Pr("fill"), Xi = G, Zi = Pr("height"), Qi = qi, ro = Pr("stroke"), no = Pr("stroke-linecap"), to = Pr("stroke-linejoin"), eo = Pr("stroke-width"), uo = Li("svg"), ao = Pr("viewBox"), io = Pr("width"), oo = F2(function(r, n) {
        var t, e = n.k, u = n.i, a = Xi(u.af), i = S([
            Yi("none"),
            Zi(w(a, u.W)),
            io(w(a, u.W)),
            ro("currentColor"),
            no("round"),
            to("round"),
            eo(Xi(u.aU)),
            ao(u.ah)
        ]), o = w((t = u.ab).$ ? i : A2(jn, Ki(t.a), i), r);
        return A2(uo, o, A2(Yt, Qi(Ut), e));
    }), fo = Gr("a"), co = function(r) {
        var n;
        return A2(Ei, "href", Mr.test(n = r) ? "" : n);
    }, so = Or, lo = function(r) {
        var n = r.av;
        return A2(fo, S([
            co(Me(r.aq)),
            Ai("bg-green-600 hover:bg-green-700 p-2 text-center rounded text-white font-bold cursor-pointer no-underline")
        ]), S([
            so(n)
        ]));
    }, bo = Gr("span"), vo = function(r) {
        return A2(bo, S([
            Ai("text-center text-xl font-bold")
        ]), S([
            so(r)
        ]));
    }, ho = F2(function(r, n) {
        return {
            $: 1,
            a: r,
            b: n
        };
    }), go = function(r) {
        return lo({
            aq: su(r),
            av: "Next"
        });
    }, po = Gr("input"), $o = function(r) {
        return p(r, !0);
    }, mo = F2(function(r, n) {
        return A2(Ui, r, {
            $: 1,
            a: n
        });
    }), wo = F2(function(r, n) {
        return A3(Kt, ae, n, r);
    }), yo = U, xo = A2(wo, S([
        "target",
        "value"
    ]), yo), ko = function(r) {
        return A2(mo, "input", A2(It, $o, A2(It, r, xo)));
    }, So = function(r) {
        return Xi(r) + "px";
    }, Io = Ei("type"), Ro = Ei("value"), Jo = F3(function(r, n, t) {
        return A2(ji, S([
            Ai("flex flex-col items-center"),
            A2(Mi, "gap", So(r / 8))
        ]), A2(nt, F2(function(t, e) {
            if (n.$) return A2(ji, S([
                A2(Mi, "height", So(r)),
                A2(Mi, "width", So(r)),
                A2(Mi, "background-color", e),
                A2(Mi, "border-radius", "5%"),
                A2(Mi, "border", "1px solid black")
            ]), y);
            var u = n.a;
            return A2(po, S([
                Io("color"),
                Ci("initVar-" + Pn(t)),
                Ro(e),
                Ai("rounded p-0 border border-black"),
                A2(Mi, "height", So(r)),
                A2(Mi, "width", So(r)),
                ko(u(t))
            ]), y);
        }), Tn(t)));
    }), Eo = {
        $: 5
    }, Ao = function(r) {
        return {
            $: 4,
            a: r
        };
    }, jo = {
        $: 1
    }, Co = function(r) {
        return {
            $: 2,
            a: r
        };
    }, qo = function(r) {
        return {
            $: 2,
            a: r
        };
    }, To = F3(function(r, n, t) {
        for(;;){
            var e = A2(Aa, Ra & n >>> r, t);
            if (e.$) return A2(Aa, Ra & n, e.a);
            r -= ft, t = e.a;
        }
    }), Lo = F2(function(r, n) {
        var t = n.a, e = n.b, u = n.c, a = n.d;
        return 0 > r || d(r, t) > -1 ? Vn : d(r, ui(t)) > -1 ? Un(A2(Aa, Ra & r, a)) : Un(A3(To, e, r, u));
    }), Fo = F2(function(r, n) {
        return Xe(A2(ca, function(n) {
            return A2(Lo, n, r);
        }, n));
    }), _o = A2(Hi, "arrow-right", S([
        A2(Fi, S([
            Bi("5"),
            zi("12"),
            Gi("19"),
            Di("12")
        ]), y),
        A2(Oi, S([
            Ni("12 5 19 12 12 19")
        ]), y)
    ])), Ho = F2(function(r, n) {
        var t = n.k;
        return {
            i: m(n.i, {
                af: r
            }),
            k: t
        };
    }), No = A2(oo, y, A2(Ho, 50, _o)), Oo = function(r) {
        return Xi(r.ad / (r.v - 1) * 100) + "%";
    }, Bo = function(r) {
        return Pn(r) + "px";
    }, Go = F2(function(r, n) {
        var t = r.as, e = r.v, u = r.ai, a = r.C, i = A2(Mi, "filter", "drop-shadow(" + So(u.n / 4) + " " + So(u.n / 4) + " " + So(u.n / 10) + " rgba(0, 0, 0, 0.5))"), o = S([
            Ai("left-0 bg-black"),
            A2(Mi, "transform", "translate(-50%, -50%)"),
            i,
            A2(Mi, "transition", "background-color 0.2s ease-in")
        ]), f = u.aJ, c = u.aT, s = u.aC, l = u.ay, v = function() {
            if (a) return S([
                Ai("bg-black")
            ]);
            switch(f.$){
                case 2:
                    return b(f.a, n) ? S([
                        Ai("cursor-pointer bg-blue-700"),
                        A2(Mi, "outline", So(u.n / 10) + " solid rgba(0, 100, 255, 0.5)"),
                        Pi(l)
                    ]) : S([
                        Ai("cursor-pointer bg-blue-600"),
                        Pi(s(n))
                    ]);
                case 1:
                    return S([
                        Ai("cursor-pointer bg-blue-600"),
                        Pi(c(n))
                    ]);
                default:
                    return S([
                        Ai("cursor-pointer bg-black"),
                        Pi(c(n))
                    ]);
            }
        }(), d = w(S([
            Ai("right-0"),
            A2(Mi, "transform", "translate(50%, -50%)"),
            i,
            A2(Mi, "transition", "background-color 0.2s ease-in")
        ]), v);
        return A2(ji, w(S([
            A2(Mi, "width", Bo(u.n)),
            A2(Mi, "height", Bo(u.n)),
            A2(Mi, "border-radius", "100%"),
            A2(Mi, "position", "absolute"),
            A2(Mi, "top", Oo({
                ad: n,
                v: e
            }))
        ]), t ? d : o), y);
    }), zo = F2(function(r, n) {
        var t = Xn(n);
        return A2(ji, S([
            A2(Mi, "position", "absolute"),
            A2(Mi, "inset", "0")
        ]), S([
            A2(uo, S([
                io("100%"),
                Zi("100%"),
                A2(Mi, "overflow", "visible")
            ]), A2(ca, function(e) {
                return A2(ke, function(n) {
                    return function(r) {
                        var n = r.v, t = r.aE, e = r.aU, u = Oo({
                            ad: r.aX,
                            v: n
                        }), a = Oo({
                            ad: t,
                            v: n
                        });
                        return A2(Fi, S([
                            zi(a),
                            Di(u),
                            Bi("0%"),
                            Gi("100%"),
                            ro("black"),
                            eo(Xi(e))
                        ]), y);
                    }({
                        aE: n,
                        aU: r,
                        aX: e,
                        v: t
                    });
                }, A2(vi, e, n));
            }, A2(rt, 0, t - 1)))
        ]));
    }), Do = j, Wo = Ei("title"), Uo = F2(function(r, n) {
        var t = Ha(n), e = A2(rt, 0, t - 1);
        return A2(ji, w(S([
            Ai("bg-gray-300"),
            A2(Mi, "border-radius", "6%"),
            A2(Mi, "padding", Bo(r.n) + " 0")
        ]), r.C ? S([
            Ai("opacity-50"),
            Wo("Turn off symmetry to edit")
        ]) : y), S([
            A2(ji, S([
                A2(Mi, "position", "relative"),
                A2(Mi, "width", Bo(5 * r.n)),
                A2(Mi, "height", Bo(Do(r.n * (t - 1) * 2)))
            ]), A2(jn, A2(zo, r.n / 10, n), w(A2(Yt, Go({
                ai: r,
                C: r.C,
                as: 0,
                v: t
            }), e), A2(Yt, Go({
                ai: r,
                C: r.C,
                as: 1,
                v: t
            }), e))))
        ]));
    }), Vo = {
        $: 0
    }, Po = F2(function(r, n) {
        return {
            $: 3,
            a: r,
            b: n
        };
    }), Mo = F2(function(r, n) {
        var t = function(r) {
            return A2(ji, S([
                Ai("border-[0.5px] border-black flex items-center justify-center"),
                A2(Mi, "width", Xi(n / 2) + "px"),
                A2(Mi, "height", Xi(n / 2) + "px")
            ]), S([
                r
            ]));
        };
        return A2(ji, S([
            A2(Mi, "display", "grid"),
            A2(Mi, "grid-template-columns", "1fr 1fr"),
            A2(Mi, "border", "1px solid black"),
            A2(Mi, "border-box", "box-sizing")
        ]), S([
            t(r.I),
            t(r.J),
            t(r.R),
            t(r.S)
        ]));
    }), Ko = F3(function(r, n, t) {
        var e = A2(Fo, n, t.J), u = A2(Fo, n, t.I), a = r / 2, i = function(n) {
            return A3(Jo, r / 16, Vn, n);
        }, o = A2(Fo, n, t.S), f = A2(Fo, n, t.R);
        return A2(Mo, {
            R: A2(Mo, {
                R: i(A2(Fo, f, t.R)),
                S: i(A2(Fo, f, t.S)),
                I: i(A2(Fo, f, t.I)),
                J: i(A2(Fo, f, t.J))
            }, a),
            S: A2(Mo, {
                R: i(A2(Fo, o, t.R)),
                S: i(A2(Fo, o, t.S)),
                I: i(A2(Fo, o, t.I)),
                J: i(A2(Fo, o, t.J))
            }, a),
            I: A2(Mo, {
                R: i(A2(Fo, u, t.R)),
                S: i(A2(Fo, u, t.S)),
                I: i(A2(Fo, u, t.I)),
                J: i(A2(Fo, u, t.J))
            }, a),
            J: A2(Mo, {
                R: i(A2(Fo, e, t.R)),
                S: i(A2(Fo, e, t.S)),
                I: i(A2(Fo, e, t.I)),
                J: i(A2(Fo, e, t.J))
            }, a)
        }, r);
    }), Yo = F2(function(r, n) {
        return 0 > d(r, n) ? r : n;
    }), Xo = A2(oo, y, A2(Ho, 20, _o)), Zo = {
        $: 0
    }, Qo = F2(function(r, n) {
        var t = p(r, n);
        r: for(;;)switch(t.b.$){
            case 1:
                if (t.a) break r;
                return Co(t.b.a);
            case 2:
                if (1 === t.a) return Co(t.b.a);
                break r;
            case 3:
                if (2 === t.a) return Co(t.b.a);
                break r;
            case 4:
                if (3 === t.a) return Co(t.b.a);
                break r;
            default:
                return jo;
        }
        return Zo;
    }), rf = F2(function(r, n) {
        var t = function(n) {
            return {
                ay: r.ay,
                C: r.ag && (2 === n || 3 === n),
                n: r.n,
                aC: r.aC,
                aJ: A2(Qo, n, r.H),
                aT: r.aT(n)
            };
        }, e = Bo(5 * r.n);
        return A2(ji, S([
            A2(Mi, "display", "grid"),
            A2(Mi, "grid-template-columns", e + " " + e),
            A2(Mi, "grid-gap", So(1.5 * r.n))
        ]), S([
            A2(Uo, t(0), n.I),
            A2(Uo, t(1), n.J),
            A2(Uo, t(2), n.R),
            A2(Uo, t(3), n.S)
        ]));
    }), nf = F2(function(r, n) {
        var t, e, u = r.b, a = r.a, i = r.H, o = r.t, f = r.V, c = A2(Yo, .9 * n, 600), s = function(r) {
            var n, t;
            return A2(ji, S([
                Ai("flex items-center justify-center gap-0.5 flex-wrap")
            ]), S([
                A3(Jo, 20, Vn, r),
                Xo,
                A2(rf, {
                    ay: Vo,
                    n: 5,
                    aC: function() {
                        return Vo;
                    },
                    H: ie,
                    aT: F2(function() {
                        return Vo;
                    }),
                    ag: !1
                }, a),
                Xo,
                (n = c / 4, t = n / 9, A2(Mo, {
                    R: A3(Jo, t, Vn, A2(Fo, r, a.R)),
                    S: A3(Jo, t, Vn, A2(Fo, r, a.S)),
                    I: A3(Jo, t, Vn, A2(Fo, r, a.I)),
                    J: A3(Jo, t, Vn, A2(Fo, r, a.J))
                }, n))
            ]));
        }, l = A2(ji, S([
            Ai("flex items-center gap-5 max-w-full flex-wrap justify-center")
        ]), S([
            A3(Jo, 30, Un(ho), u),
            No,
            A2(rf, {
                ay: Eo,
                n: 20,
                aC: Ao,
                H: i,
                aT: Po,
                ag: !1
            }, a),
            No,
            A2(Mo, {
                R: A3(Jo, 30, Vn, A2(Fo, u, a.R)),
                S: A3(Jo, 30, Vn, A2(Fo, u, a.S)),
                I: A3(Jo, 30, Vn, A2(Fo, u, a.I)),
                J: A3(Jo, 30, Vn, A2(Fo, u, a.J))
            }, A2(Yo, .9 * n, 300))
        ])), b = S([
            (e = S([
                "We then repeat this process in each quadrant.",
                "The output list in each quadrant becomes the input list for the next level."
            ]), A2(ji, S([
                Ai("flex flex-col items-center gap-3")
            ]), A2(Yt, vo, e))),
            f ? A2(Mo, {
                R: s(A2(Fo, u, a.R)),
                S: s(A2(Fo, u, a.S)),
                I: s(A2(Fo, u, a.I)),
                J: s(A2(Fo, u, a.J))
            }, c) : A3(Ko, c, u, a),
            A2(Ri, S([
                Pi((t = !f, {
                    $: 6,
                    a: t
                })),
                Ai("p-2 text-center rounded-md text-black border border-black font-bold no-underline cursor-pointer hover:bg-neutral-50")
            ]), S([
                so(f ? "Show output" : "Show process")
            ])),
            vo("For each additional level of recursion, we will apply the permutations again to each output from the previous level, subdividing each square into 4 smaller quadrants."),
            go(3)
        ]);
        return A2(ji, S([
            Ai("flex flex-col items-center gap-5 p-5")
        ]), w(S([
            vo("We will have 4 permutations, one for each quadrant."),
            vo("After applying these permutations to the input list of colors, we end up with an output list for each quadrant."),
            l
        ]), o ? b : S([
            vo("Try changing the permutations and see how the output changes")
        ])));
    }), tf = F2(function(r, n) {
        var t, e, u, a, i, o, f = r.b, c = r.a, s = r.H, l = (t = A2(Fo, f, c.J), e = A2(Fo, f, c.I), u = function(r) {
            return A2(ji, S([
                A2(Mi, "background-color", A2(Pe, "white", A2(Lo, 0, r))),
                A2(Mi, "width", Bo(A2(Yo, n / 5 | 0, 100))),
                A2(Mi, "height", Bo(A2(Yo, n / 5 | 0, 100)))
            ]), y);
        }, a = function(r) {
            var n = r.I, t = r.J, e = r.R, a = r.S;
            return A2(ji, S([
                A2(Mi, "display", "grid"),
                A2(Mi, "grid-template-columns", "1fr 1fr")
            ]), S([
                u(n),
                u(t),
                u(e),
                u(a)
            ]));
        }, i = A2(Fo, f, c.S), o = A2(Fo, f, c.R), A2(ji, S([
            A2(Mi, "display", "grid"),
            A2(Mi, "grid-template-columns", "1fr 1fr"),
            A2(Mi, "border", "1px solid black")
        ]), S([
            a({
                R: A2(Fo, e, c.R),
                S: A2(Fo, e, c.S),
                I: A2(Fo, e, c.I),
                J: A2(Fo, e, c.J)
            }),
            a({
                R: A2(Fo, t, c.R),
                S: A2(Fo, t, c.S),
                I: A2(Fo, t, c.I),
                J: A2(Fo, t, c.J)
            }),
            a({
                R: A2(Fo, o, c.R),
                S: A2(Fo, o, c.S),
                I: A2(Fo, o, c.I),
                J: A2(Fo, o, c.J)
            }),
            a({
                R: A2(Fo, i, c.R),
                S: A2(Fo, i, c.S),
                I: A2(Fo, i, c.I),
                J: A2(Fo, i, c.J)
            })
        ])));
        return A2(ji, S([
            Ci("page"),
            Ai("flex flex-col items-center gap-5 p-5")
        ]), S([
            vo("We can continue to apply the permutations recursively, and we end up with a grid of color lists."),
            A2(ji, S([
                Ai("flex items-center gap-5 flex-wrap justify-center")
            ]), S([
                A3(Jo, 30, Un(ho), f),
                No,
                A2(rf, {
                    ay: Eo,
                    n: 20,
                    aC: Ao,
                    H: s,
                    aT: Po,
                    ag: !1
                }, c),
                A2(ji, S([
                    Ai("flex flex-col items-center")
                ]), S([
                    so("1 level"),
                    No
                ])),
                A2(Mo, {
                    R: A3(Jo, 30, Vn, A2(Fo, f, c.R)),
                    S: A3(Jo, 30, Vn, A2(Fo, f, c.S)),
                    I: A3(Jo, 30, Vn, A2(Fo, f, c.I)),
                    J: A3(Jo, 30, Vn, A2(Fo, f, c.J))
                }, 300),
                A2(ji, S([
                    Ai("flex flex-col items-center justify-center")
                ]), S([
                    so("2 levels"),
                    No
                ])),
                A3(Ko, 300, f, c)
            ])),
            vo("But after some number of levels, we will want to transform the grid of color lists into an image."),
            vo("We use the first color from a list as the value for that location in the image."),
            A2(ji, S([
                Ai("flex items-center gap-5 flex-wrap justify-center")
            ]), S([
                A3(Ko, A2(Yo, .9 * n, 400), f, c),
                No,
                l
            ])),
            vo("Try changing the initial colors and permutations to see how the output changes"),
            go(4)
        ]));
    }), ef = Pr("color"), uf = Li("circle"), af = Pr("cx"), of = Pr("cy"), ff = Pr("r"), cf = A2(Hi, "x-circle", S([
        A2(uf, S([
            af("12"),
            of("12"),
            ff("10")
        ]), y),
        A2(Fi, S([
            Bi("15"),
            zi("9"),
            Gi("9"),
            Di("15")
        ]), y),
        A2(Fi, S([
            Bi("9"),
            zi("9"),
            Gi("15"),
            Di("15")
        ]), y)
    ])), sf = A2(fo, S([
        co(Me(oe(Vn)))
    ]), S([
        A2(oo, S([
            ef("black")
        ]), A2(Ho, 30, cf))
    ])), lf = F2(function(r, n) {
        var t = function() {
            switch(r.$){
                case 0:
                    return e = (t = r.a).b, u = t.ac, A2(ji, S([
                        Ai("flex flex-col items-center gap-5 p-5")
                    ]), S([
                        vo("We start with a list of colors."),
                        A3(Jo, 30, Un(ho), e),
                        vo("Try changing the value of a color"),
                        u ? go(1) : so("")
                    ]));
                case 1:
                    return function(r) {
                        var n = r.b, t = r.U, e = r.G, u = r.t;
                        return A2(ji, S([
                            Ai("flex flex-col items-center gap-5 p-5")
                        ]), w(S([
                            vo("A permutation changes the order of a list of colors"),
                            A2(ji, S([
                                Ai("flex flex-wrap items-center justify-center gap-4")
                            ]), S([
                                A3(Jo, 30, Un(ho), n),
                                No,
                                A2(Uo, {
                                    ay: Eo,
                                    C: !1,
                                    n: 20,
                                    aC: Ao,
                                    aJ: e.$ ? jo : Co(e.a),
                                    aT: qo
                                }, t),
                                No,
                                A3(Jo, 30, Vn, A2(Fo, n, t))
                            ]))
                        ]), S(u ? [
                            vo("See how the output changes depending on the permutation"),
                            go(2)
                        ] : 1 === e.$ ? [
                            vo("Try clicking one of the blue dots on the permutation")
                        ] : [
                            vo("Now click on another blue dot to swap those positions in the permutation")
                        ])));
                    }(r.a);
                case 2:
                    return A2(nf, r.a, n);
                case 3:
                    return A2(tf, r.a, n);
                default:
                    return A2(ji, S([
                        Ai("flex flex-col items-center gap-5 p-5")
                    ]), S([
                        vo("You have now seen how we will generate an image from an initial list of colors and 4 permutations."),
                        vo("In this tutorial, the number of colors was always 3, and we only showed up to 2 levels of recursion."),
                        vo("In the actual application, you can change the number of colors and the level of recursion."),
                        vo("You will also be able to randomize the permutations. There is a 'Random' button that will generate all 4 permutations randomly, and a 'Random Symmetric' button that will generate 2 random permutation and have equal diagonal permutations (because symmetry is pretty)."),
                        vo("Clicking on the image does the same thing as clicking the 'Random Symmetric' button."),
                        lo({
                            aq: oe(Vn),
                            av: "Done"
                        })
                    ]));
            }
            var t, e, u;
        }();
        return A2(ji, S([
            Ai("font-sans relative flex flex-col h-screen w-screen overflow-scroll"),
            Ci("page")
        ]), S([
            A2(ji, S([
                Ai("flex flex-col items-center p-5 border-b border-b-black text-3xl font-bold")
            ]), S([
                so("Tutorial")
            ])),
            A2(ji, S([
                Ai("absolute top-3 right-3")
            ]), S([
                sf
            ])),
            t
        ]));
    }), bf = F2(function(r, n) {
        return {
            $: 5,
            a: r,
            b: n
        };
    }), vf = Pr("d"), df = Li("path"), hf = A2(Hi, "help-circle", S([
        A2(uf, S([
            af("12"),
            of("12"),
            ff("10")
        ]), y),
        A2(df, S([
            vf("M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3")
        ]), y),
        A2(Fi, S([
            Bi("12"),
            zi("17"),
            Gi("12.01"),
            Di("17")
        ]), y)
    ])), gf = A2(fo, S([
        co(Me(su(0)))
    ]), S([
        A2(oo, S([
            ef("black")
        ]), A2(Ho, 30, hf))
    ])), pf = F2(function(r, n) {
        return A2(ji, S([
            Ai("flex flex-col items-center gap-2")
        ]), A2(jn, A2(bo, S([
            Ai("font-semibold")
        ]), S([
            so(r)
        ])), n));
    }), $f = function(r) {
        return {
            $: 6,
            a: r
        };
    }, mf = Ei("htmlFor"), wf = Gr("label"), yf = Ei("max"), xf = Ei("min"), kf = function(r) {
        return {
            $: 7,
            a: r
        };
    }, Sf = {
        $: 10
    }, If = {
        $: 4
    }, Rf = function(r) {
        return {
            $: 9,
            a: r
        };
    }, Jf = F2(function(r, n) {
        return {
            $: 8,
            a: r,
            b: n
        };
    }), Ef = function(r) {
        return {
            $: 14,
            a: r
        };
    }, Af = ar, jf = F2(function(r, n) {
        return A2(Vr, r, Af(n));
    })("checked"), Cf = W, qf = A2(wo, S([
        "target",
        "checked"
    ]), Cf), Tf = F2(function(r, n) {
        var t, e;
        return A2(pf, "Permutations", S([
            A2(rf, {
                ay: Sf,
                n: 20,
                aC: Rf,
                H: r,
                aT: Jf,
                ag: n.ag
            }, n.a),
            A2(ji, S([
                Ai("flex gap-2 items-center justify-items-center m-1 text-sm")
            ]), S([
                A2(Ri, S([
                    Ai("border border-black rounded-md px-2 hover:bg-neutral-200"),
                    Pi(Ii)
                ]), S([
                    so("Random")
                ])),
                A2(Ri, S([
                    Ai("border border-black rounded-md px-2 hover:bg-neutral-200"),
                    Pi(If)
                ]), S([
                    so("Clear")
                ]))
            ])),
            (t = n.ag, A2(wf, S([
                Ai("inline-flex items-center cursor-pointer")
            ]), S([
                A2(bo, S([
                    Ai("me-3 text-sm font-medium text-gray-900")
                ]), S([
                    so("Symmetric")
                ])),
                A2(po, S([
                    Io("checkbox"),
                    Ro(""),
                    Ai("sr-only peer"),
                    jf(t),
                    (e = Ef, A2(Vi, "change", A2(It, e, qf)))
                ]), y),
                A2(ji, S([
                    Ai("relative w-11 h-6 bg-gray-300 peer-focus-visible:outline-none peer-focus-visible:ring-4 peer-focus-visible:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-400 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600")
                ]), y)
            ])))
        ]));
    }), Lf = F2(function(r, n) {
        var t, e, u, a, i, o, f, c;
        return A2(ji, S([
            Ai("h-full grow-[2] overflow-y-scroll bg-gray-100 relative tall:w-full text-gray-900")
        ]), S([
            A2(ji, S([
                Ai("absolute top-3 right-3")
            ]), S([
                gf
            ])),
            A2(ji, S([
                Ai("flex flex-col items-center gap-5 my-12 mx-3")
            ]), S([
                A2(ji, S([
                    Ai("text-2xl font-bold")
                ]), S([
                    so("Fraquilt")
                ])),
                (e = n.aG, A2(pf, "Level", S([
                    (u = {
                        a9: "level",
                        bd: 10,
                        be: 1,
                        bf: $f,
                        br: e
                    }, a = u.a9, i = u.br, o = u.bf, f = u.be, c = u.bd, A2(ji, S([
                        Ai("flex items-center gap-1")
                    ]), S([
                        A2(wf, S([
                            mf(a),
                            Ai("w-7 text-right")
                        ]), S([
                            so(Pn(i))
                        ])),
                        A2(po, S([
                            Ci(a),
                            Io("range"),
                            xf(Pn(f)),
                            yf(Pn(c)),
                            Ro(Pn(i)),
                            ko(o)
                        ]), y)
                    ])))
                ]))),
                A2(Tf, r, n),
                (t = Wa(n.y), A2(pf, "Number of colors", S([
                    A2(ji, S([
                        Ai("flex items-center gap-2")
                    ]), S([
                        A2(Ri, S([
                            Ai("border border-black rounded-md px-2 hover:bg-neutral-200"),
                            Pi(kf(t - 1))
                        ]), S([
                            so("-")
                        ])),
                        A2(bo, y, S([
                            so(Pn(t))
                        ])),
                        A2(Ri, S([
                            Ai("border border-black rounded-md px-2 hover:bg-neutral-200"),
                            Pi(kf(t + 1))
                        ]), S([
                            so("+")
                        ]))
                    ]))
                ]))),
                A2(pf, "Initial Colors", S([
                    A3(Jo, 30, Un(bf), n.y)
                ]))
            ]))
        ]));
    });
    sa = {
        Main: {
            init: (ba = (la = {
                bb: Mu,
                bj: function(r) {
                    return {
                        $: 1,
                        a: r
                    };
                },
                bk: function(r) {
                    return {
                        $: 2,
                        a: r
                    };
                },
                bo: function() {
                    return A3(ga, 1, "resize", A2(ae, "target", A3(Rt, Yu, A2(ae, "innerWidth", Ku), A2(ae, "innerHeight", Ku))));
                },
                bq: ki,
                bs: function(r) {
                    var n;
                    return {
                        a2: (n = r.w, S(n.$ ? [
                            A2(ji, S([
                                Ai("flex items-center h-screen w-screen font-sans overflow-auto justify-between flex-wrap tall:flex-nowrap tall:justify-normal tall:flex-col tall:overflow-hidden")
                            ]), S([
                                A2(ji, S([
                                    Ai("m-3 flex items-center justify-center grow flex-wrap")
                                ]), S([
                                    A2(ji, S([
                                        Ai("max-w-[90vw] max-h-[90vh] w-[90vmin] h-[90vmin]")
                                    ]), S([
                                        A2(Ji, S([
                                            Ci("canvas"),
                                            Ai("cursor-pointer w-full h-full border-2 border-black"),
                                            A2(Mi, "image-rendering", "pixelated"),
                                            Pi(Ii)
                                        ]), y)
                                    ])),
                                    A2(Ri, S([
                                        Pi(Si),
                                        Ai("self-end mx-6 mt-3")
                                    ]), S([
                                        A2(oo, y, A2(Ho, 20, Wi))
                                    ]))
                                ])),
                                A2(Lf, r.H, r.e)
                            ]))
                        ] : [
                            A2(Ti, xa, A2(lf, n.a, r.L.al))
                        ])),
                        bp: "Fraquilt"
                    };
                }
            }).bj, va = la.bk, da = function() {
                da.a(ba(xn()));
            }, wn({
                ar: function(r) {
                    return da.a = r, Rn.addEventListener("popstate", da), 0 > Rn.navigator.userAgent.indexOf("Trident") || Rn.addEventListener("hashchange", da), F2(function(n, t) {
                        if (!(t.ctrlKey || t.metaKey || t.shiftKey || t.button >= 1 || n.target || n.hasAttribute("download"))) {
                            t.preventDefault();
                            var e = n.href, u = xn(), a = Wt(e).a;
                            r(va(a && u.aO === a.aO && u.aF === a.aF && u.aL.a === a.aL.a ? {
                                $: 0,
                                a: a
                            } : function(r) {
                                return {
                                    $: 1,
                                    a: r
                                };
                            }(e)));
                        }
                    });
                },
                bb: function(r) {
                    return A3(la.bb, r, xn(), da);
                },
                bs: la.bs,
                bq: la.bq,
                bo: la.bo
            }))(A2(St, function(r) {
                return A2(St, function(n) {
                    return Jt({
                        q: n,
                        L: r
                    });
                }, A2(ae, "randomSeed", Ku));
            }, A2(ae, "window", A2(St, function(r) {
                return A2(St, function(n) {
                    return Jt({
                        al: n,
                        aZ: r
                    });
                }, A2(ae, "height", Ku));
            }, A2(ae, "width", Ku)))))(0)
        }
    }, r.Elm ? function r(n, t) {
        for(var e in t)e in n ? "init" == e ? l(6) : r(n[e], t[e]) : n[e] = t[e];
    }(r.Elm, sa) : r.Elm = sa;
}($a0b4f895e1596b3b$exports);


const $ccb833f2aae24c7e$var$app = (0, $a0b4f895e1596b3b$exports.Elm).Main.init({
    flags: {
        randomSeed: new Date().getMilliseconds(),
        window: {
            width: window.innerWidth,
            height: window.innerHeight
        }
    }
});
$ccb833f2aae24c7e$var$app.ports.makeFullscreen.subscribe(()=>{
    const canvas = document.getElementById("canvas");
    if (canvas) canvas.requestFullscreen();
});
$ccb833f2aae24c7e$var$app.ports.renderImage.subscribe(({ permutations: permutations, level: level, initialVariables: initialVariables })=>{
    const initialVarsColors = initialVariables.map($ccb833f2aae24c7e$var$hexToRgb);
    $ccb833f2aae24c7e$var$generateImage(permutations, level, initialVarsColors);
});
function $ccb833f2aae24c7e$var$hexToRgb(hex) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return {
        r: r,
        g: g,
        b: b
    };
}
function $ccb833f2aae24c7e$var$generateImage(permutations, level, initialVariables, tries = 0) {
    const canvas = document.getElementById("canvas");
    if (!canvas) // If the canvas isn't in the dom yet, try again in 100ms
    {
        if (tries < 10) setTimeout(()=>$ccb833f2aae24c7e$var$generateImage(permutations, level, initialVariables, tries + 1), 100);
    } else {
        const ctx = canvas.getContext("2d");
        const pixelSize = $ccb833f2aae24c7e$var$pixelSizeForLevel(level);
        canvas.width = pixelSize;
        canvas.height = pixelSize;
        const imageData = ctx.createImageData(pixelSize, pixelSize);
        $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level, initialVariables, {
            x: 0,
            y: 0
        });
        ctx.putImageData(imageData, 0, 0);
    }
}
function $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level, colorVariables, location) {
    if (level == 0) $ccb833f2aae24c7e$var$setPixelColor(imageData, colorVariables, location);
    else {
        const { tl: tl, tr: tr, bl: bl, br: br } = permutations;
        $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level - 1, $ccb833f2aae24c7e$var$permute(tl, colorVariables), $ccb833f2aae24c7e$var$topLeftLocation(location, level));
        $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level - 1, $ccb833f2aae24c7e$var$permute(tr, colorVariables), $ccb833f2aae24c7e$var$topRightLocation(location, level));
        $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level - 1, $ccb833f2aae24c7e$var$permute(bl, colorVariables), $ccb833f2aae24c7e$var$bottomLeftLocation(location, level));
        $ccb833f2aae24c7e$var$fraquilt(imageData, permutations, level - 1, $ccb833f2aae24c7e$var$permute(br, colorVariables), $ccb833f2aae24c7e$var$bottomRightLocation(location, level));
    }
}
// Utils
function $ccb833f2aae24c7e$var$setPixelColor(imageData, [color], { x: x, y: y }) {
    const i = y * (imageData.width * 4) + x * 4;
    const buf = imageData.data;
    buf[i] = color.r;
    buf[i + 1] = color.g;
    buf[i + 2] = color.b;
    buf[i + 3] = 255;
}
function $ccb833f2aae24c7e$var$permute(adjustmentArray, colorVariables) {
    const newColorVariables = [
        ...colorVariables
    ];
    for(let i = 0; i < colorVariables.length; i++)newColorVariables[i] = colorVariables[adjustmentArray[i]];
    return newColorVariables;
}
function $ccb833f2aae24c7e$var$pixelSizeForLevel(level) {
    return 2 ** level;
}
function $ccb833f2aae24c7e$var$topLeftLocation({ x: x, y: y }, level) {
    return {
        x: x,
        y: y
    };
}
function $ccb833f2aae24c7e$var$topRightLocation({ x: x, y: y }, level) {
    return {
        x: x + $ccb833f2aae24c7e$var$pixelSizeForLevel(level - 1),
        y: y
    };
}
function $ccb833f2aae24c7e$var$bottomLeftLocation({ x: x, y: y }, level) {
    return {
        x: x,
        y: y + $ccb833f2aae24c7e$var$pixelSizeForLevel(level - 1)
    };
}
function $ccb833f2aae24c7e$var$bottomRightLocation({ x: x, y: y }, level) {
    return {
        x: x + $ccb833f2aae24c7e$var$pixelSizeForLevel(level - 1),
        y: y + $ccb833f2aae24c7e$var$pixelSizeForLevel(level - 1)
    };
}


//# sourceMappingURL=index.145da554.js.map
